export const functionalitiesAlias = {
  'cartao-virtual': 'virtualCard',
  'declaração-de-irs': 'IRS',
  'historico-de-utilizacao': 'insuranceHistory',
  registo: 'register',
  login: 'login',
  'mensagens-gerais': 'messages',
  'historico-de-reembolso': 'refund',
  'pedir-reembolso': 'createRefund',
  inicio: 'start',
  'o-meu-perfil': 'myProfile',
  'rede-precos': 'redePrecos',
  'health-score': 'healthScore',
  'pre-autorizacoes': 'preAuthorizations', //preAuthorizations
  'dados-pessoais': 'myData',
  'iban-para-reembolsos': 'ibanRefunds',
  'fale-connosco': 'talkWithUs',
  footer: 'footer',
  'as-minhas-coberturas': 'myCoverages',
  'alterar-palavra-passe': 'changePassword',
  'perguntas-frequentes': 'frequentQuestions',
  'condicoes-gerais-da-apolice': 'generalConditions',
  mais: 'mais',
  pedidos: 'pedidos',
  permissoes: 'permissions',
  'protecao-de-dados-pessoais': 'personalDataProtection',
  'politica-de-privacidade': 'privacyPolicy',
  'guia-rapido': 'quickGuide',
  seguro: 'seguro',
  menu: 'menu',
  'termos-e-condicoes': 'termsConditions',
  'os-meus-servicos': 'services',
  'informacoes-legais': 'legalInformation',
  onetrust: 'oneTrust',
  rede: 'rede',
  pinAuthorization: 'pinAuthorization',
  'consulta-online': 'appointments',
  'confirmar-dados-pessoais': 'personalInfoConfirmation',
  'registo-cmd': 'registoCMD',
  'guia-do-cliente': 'clientGuide',
  'multi-lingua': 'multiLanguage',
  'pre-comparticipacao': 'preComparticipacao',
  'google-analytics-gtm': 'googleanalyticsgtm',
};

export const functionalitiesAliasMap = {
  healthScore: 'health-score',
  authorization: 'pre-autorizacoes',
  refund: 'historico-de-reembolso',
  createRefund: 'pedir-reembolso',
  changePassword: 'alterar-palavra-passe',
  myData: 'dados-pessoais',
  iban: 'iban-para-reembolsos',
  menuMore: 'mais',
  menuRequests: 'pedidos',
  menuNetwork: 'rede',
  menuInsurance: 'seguro',
  menuStart: 'inicio',
  myProfile: 'o-meu-perfil',
  permissions: 'permissoes',
  quickGuide: 'guia-rapido',
  talkWithUs: 'fale-connosco',
  faq: 'perguntas-frequentes',
  privacyPolicy: 'politica-de-privacidade',
  dataProtection: 'protecao-de-dados-pessoais',
  termsAndConditions: 'termos-e-condicoes',
  footer: 'footer',
  generalConditions: 'condicoes-gerais-da-apolice',
  coverages: 'as-minhas-coberturas',
  register: 'registo',
  login: 'login',
  menu: 'menu',
  generalMessages: 'mensagens-gerais',
  utilization: 'historico-de-utilizacao',
  irs: 'declaração-de-irs',
  virtualCard: 'cartao-virtual',
  legalInformation: 'informacoes-legais',
  oneTrust: 'onetrust',
  rede: 'rede',
  pinAuthorization: 'pinAuthorization',
  appointments: 'consulta-online',
  personalInfoConfirmation: 'confirmar-dados-pessoais',
  registoCMD: 'registo-cmd',
  services: 'os-meus-servicos',
  clientGuide: 'guia-do-cliente',
  multiLanguage: 'multi-lingua',
  redePrecos: 'rede-precos',
  googleanalyticsgtm: 'google-analytics-gtm',
};

// Todas as strings aqui adicionadas devem ser comunicadas a alguém do backend para pôr no backoffice.
export const strings = {
  pt: {
    healthScore: {
      healthScore_advanceCarePlus: 'Advance Care+',
      healthScore_levelOfHealth: 'Quer saber qual é o seu nível bem-estar?',
      healthScore_joinAdvanceCarePlus:
        'Adira ao AdvanceCare+ e acompanhe o seu progresso de saúde, estilo de vida e estado emocional.',
      healthScore_joinNow: 'Adira Já',
      healthScore_myScore: 'O meu score',
      healthScore_lifestyle: 'Estilo de vida',
      healthScore_body: 'Corpo',
      healthScore_emotions: 'Emoções',
      healthScore_link: 'https://www.advancecare.pt/',
    },
    authorization: {
      medicalActIn: 'Ato médico em',
    },
    preAuthorizations: {
      preAuthorizations_title: 'Pré-autorizações',
      preAuthorizations_noRequest: 'Ainda não foi realizado nenhum pedido.',
      preAuthorizations_inRequest: 'Quando solicitar uma pré-autorização',
      preAuthorizations_ask: 'Pedir Pré-Autorização',
      preAuthorizations_documents: 'Ainda não tem os documentos?',
      preAuthorizations_getDocuments: 'Obter documentos',
      preAuthorizations_verifyDocuments: 'Já tem os documentos?',
      preAuthorizations_submitRequest: 'Submeter pedido',
      preAuthorizations_procedureType:
        'Selecione o tipo de procedimento para obter os documentos',
      preAuthorizations_procedure: 'Procedimento',
      preAuthorizations_select: 'Selecionar',
      preAuthorizations_textPrint:
        'Deverá imprimir o formulário de pedido de informação clínica e solicitar ao seu médico o respectivo preenchimento. \r\n\r\nEm caso de acidente, anexar descrição detalhada do que originou a lesão.',
      preAuthorizations_requestOutNetwork:
        'Pedido pré autorização fora da rede AdvanceCare',
      preAuthorizations_textProcedure:
        'Sempre que o procedimento requer pré-autorização é da responsabilidade da pessoas segura enviar o mesmo. Sem este pedido prévio, no momento da realização do serviço de saúde, não terá assegurado o pagamento da sua despesa.',
      preAuthorizations_needPreAuthorization:
        'Procedimentos que precisam de pré-autorização',
      preAuthorizations_textNeedPreAuthorization:
        'É necessário fazer um pedido de pré autorização para os seguintes serviços de saúde: cirurgias, internamentos, fisioterapia, cinesioterapia, terapia da fala, quimioterapia, radioterapia, meios auxiliares de diagnóstico e outras situações referenciadas nas condições da apólice.',
      preAuthorizations_understood: 'Compreendi',
      preAuthorizations_fillData: 'Preencha os seguintes dados',
      preAuthorizations_pacient: 'Paciente*',
      preAuthorizations_selectPacient: 'Selecione o paciente',
      preAuthorizations_procedure2: 'Procedimento*',
      preAuthorizations_selectProcedure: 'Selecione o procedimento',
      preAuthorizations_procedureDate: 'Data do procedimento*',
      preAuthorizations_comments: 'Comentários e notas',
      preAuthorizations_insertComments: 'Insira comentários e notas',
      preAuthorizations_attachment: 'Anexar informação clínica',
      preAuthorizations_addClinicInfo: 'Incluir pedido de informação clínica',
      preAuthorizations_attachOtherDocuments: 'Anexar outros documentos',
      preAuthorizations_required: '(*) preenchimento obrigatório',
      preAuthorizations_documentType: 'Tipo de documento',
      preAuthorizations_confirm: 'Confirmar',
      preAuthorizations_sent: 'Enviado com sucesso',
      preAuthorizations_consultDetails:
        'Pode consultar os detalhes na lista de pedidos de pré-autorizações',
      preAuthorizations_process: 'Processo',
      preAuthorizations_patient2: 'Paciente',
      preAuthorizations_procedureDate2: 'Data do procedimento',
      preAuthorizations_attachedDocuments: 'Documentos Anexados',
      preAuthorizations_accidentText:
        'Em caso de acidente, anexar descrição detalhada do que originou a lesão.',
      preAuthorizations_provider: 'Prestador',
      preAuthorizations_issuedDocuments: 'Documentos Emitidos\r\n-',
      refund_preAuthorization_subTitle:
        'Verifique o estado dos seus pedidos de pré-autorizações',
      refund_preAuthorization_PedirPreAutorizacao: 'Pedir pré-autorização',
      filterDateLabel: 'Período',
      refund_preAuthorization_filter_button: 'Filtrar',
      refund_preAuthorizationRequest_firstTitle:
        'Pedido pré autorização fora da rede AdvanceCare',
      refund_preAuthorizationRequest_firstText:
        'Sempre que o procedimento requer pré-autorização é da responsabilidade da pessoas segura enviar o mesmo. Sem este pedido prévio, no momento da realização do serviço de saúde, não terá assegurado o pagamento da sua despesa.',
      refund_preAuthorizationRequest_secondTitle:
        'Procedimentos que precisam de pré-autorização',
      refund_preAuthorizationRequest_secondText:
        'É necessário fazer um pedido de pré autorização para os seguintes serviços de saúde: cirurgias, internamentos, fisioterapia, cinesioterapia, terapia da fala, quimioterapia, radioterapia, meios auxiliares de diagnóstico e outras situações referenciadas nas condições da apólice.',
      refund_preAuthorizationRequest_button: 'Compreendi',
      refund_preAuthorization: 'Pré-Autorizações',
      refund_preAuthorization_addPreAuthorization: 'Pedir Pré-Autorização',
      refund_preAuthorization_whenAddPreAuthorization:
        'Quando solicitar uma pré-autorização',
      refund_preAuthorization_filter_title: 'Filtrar Pré-autorizações',
      refund_preAuthorization_filter_processTypeLabel: 'Procedimento',
      refund_preAuthorization_filter_processStatusLabel: 'Estado',
      refund_preAuthorization_detail_title: 'Pedido de pré-autorização',
      refund_preAuthorization_detail_emitDocLabel: 'Documentos Emitidos',
      refund_preAuthorization_detail_emitDoc_visible: '1',
      authorization_requestOfPreAuthorization: 'Pedido de pré-autorização',
      authorization_dontHaveTheDocumentsYet: 'Ainda não tem os documentos?',
      authorization_obtainDocuments: 'Obter documentos',
      authorization_alreadyHaveTheDocuments: 'Já tem os documentos?',
      authorization_submitRequest: 'Submeter pedido',
      authorization_header: 'Pré-Autorização',
      authorization_addData:
        'Selecione o tipo de procedimento para obter os documentos:',
      authorization_patient: 'Paciente',
      authorization_selectPatient: 'Selecione o paciente',
      authorization_procedure: 'Procedimento',
      authorization_selectProcedure: 'Selecionar',
      authorization_procedureDate: 'Data do procedimento',
      authorization_procedureDatePlaceholder: 'DD-MM-AAAA',
      authorization_comments: 'Comentários e notas',
      authorization_commentsPlacholder: 'Insira comentários e notas',
      authorization_clinicalInfo: 'Anexar informação clínica',
      authorization_clinicalInfoDesc: 'Incluir pedido de informação clinica',
      authorization_documentType: 'Tipo de documento',
      authorization_confirm: 'Confirmar',
      authorization_otherDocuments: 'Anexar outros documentos',
      authorization_obligatoryFields: '(*) preenchimento obrigatório',
      authorization_send: 'Enviar',
      authorization_sentSuccess: 'Enviado com sucesso',
      authorization_sentSuccessDescription:
        'Pode consultar os detalhes na lista dos pedidos de pré-autorizações',
      authorization_selectDocuments:
        'Selecione o tipo de procedimento para obter os documentos:',
      authorization_printFormWarning:
        'Deverá imprimir o formulário de pedido de informação clínica e solicitar ao seu médico o respetivo preenchimento.',
      authorization_inCaseOfAccident:
        'Em caso de acidente, anexar descrição detalhada do que originou a lesão.',
      authorization_emittedDocuments: 'Documentos Emitidos',
      authorization_responseIn72hours: 'Receba a resposta até 72h úteis',
      authorization_chooseTypeOfDocuments:
        'Selecione o tipo de procedimento para obter os documentos:',
      authorization_availableDocuments: 'Documentos disponíveis',
      authorization_impressForm:
        'Deverá imprimir o formulário de pedido de informação clínica e solicitar ao seu médico o respectivo preenchimento.',
      authorization_caseOfAcident:
        'Em caso de acidente, anexar descrição detalhada do que originou a lesão.',
      authorization_leaveRequest: 'Sair do pedido',
      authorization_close: 'Fechar',
      authorization_sendWithSucess: 'Enviado com sucesso!',
      authorization_process: 'Processo:',
      authorization_proceed: 'Procedimento:',
      authorization_ocurrenceDate: 'Data de ocorrência:',
      authorization_provider: 'Prestador:',
      authorization_occurredAnError: 'Ocorreu um erro a processar o seu pedido',
      authorization_documents: 'Documentos',
      authorization_data: 'Dados',
      refund_all_option: 'Todos',
      medicalActIn: 'Ato médico em',
      authorization_inactive_functionality:
        'A sua seguradora não tem acesso à submissão de pré-autorizações',
      delete_document: 'Apagar documento',
      refundDetail_deductContext: 'Contextualização franquia',
      refundDetail_notAuthorizedContext:
        'Contextualização valor não autorizado',
    },
    refund: {
      default_currency: '€',
      refundHistory_understood: 'Compreendi',
      refundHistory_noDataFound:
        'Não existem informações disponíveis para o período indicado',
      refundHistory_emptyList: 'Ainda não foi realizado nenhum pedido.',
      refundHistory_filterButton: 'Filtro',
      filterTitle: 'Filtrar Reembolsos',
      filterCoverageLabel: 'Cobertura',
      filterStatusLabel: 'Estado',
      filterDateLabel: 'Período ',
      filterButtonText: 'Filtrar',
      refundHistory_addRefund: 'Pedir Reembolso',
      refundHistory_ibanError:
        'Por favor defina um IBAN para iniciar os seus reembolsos.',
      refundHistory_ibanError_not_titular:
        'Para alteração do IBAN solicitar ao titular da sua conta.',
      refundHistory_defineIban: 'Definir IBAN',
      refundHistory_detailsHeader: 'Pedido de reembolso',
      refund_preAuthorization: 'Pré-Autorizações',
      refundHistory_title: 'Reembolsos',
      refundHistory_text:
        'Faça o pedido de reembolso pelo myAdvanceCare e receba o pagamento até 72h úteis',
      refundHistory_verifyRequest:
        'Verifique o estado dos seus pedidos de reembolso',
      refundHistory_declarations: 'Declarações',
      refundDetail_title: 'Reembolso',
      refundDetail_sendByMe: 'ENVIADO POR MIM',
      refundDetail_process: 'Processo',
      refundDetail_pacient: 'Paciente',
      refundDetail_provider: 'Prestador',
      refundDetail_date: 'Data da ocorrência:',
      refundDetail_coverage: 'Cobertura:',
      refundDetail_medicalAct: 'Ato Médico:',
      refundDetail_value: 'Valor:',
      refundDetail_client: 'A cargo do cliente: ',
      refundDetail_insurance: 'A cargo da seguradora: ',
      refundDetail_refundValue: 'Valor reembolsado:',
      refundDetail_totalValue: 'Valor total:',
      refundDetail_anexDoc: 'Documentos Anexados',
      refundDetail_emitDoc: 'Documentos Emitidos',
      refundDetail_deduct: 'Franquia',
      refundDetail_copay: 'Copagamento',
      refundDetail_disallow: 'Não autorizado',
      refundDetail_readingError: 'Houve um problema na leitura da fatura',
      refundDetail_sendByMeNormalCase: 'Enviado por mim',
      refundDetail_issuedOnUpperCase: 'ENVIADO EM',
      refundDetail_processedOnUpperCase: 'PROCESSADO EM',
      refundDetail_destinationIBANUpperCase: 'IBAN DE DESTINO',
      refundDetail_reason: 'Motivo de recusa do pedido',
      sendBy: 'ENVIADO POR MIM',
      refundDetail_dateInfo:
        'Data de emissão do pagamento. A disponibilidade do valor em conta depende das condições do serviço bancário.',
      refund_all_option: 'Todos',
      medicalActIn: 'Ato médico em',
      refundDetail_deductContext: 'Contextualização franquia',
      refundDetail_notAuthorizedContext:
        'Contextualização valor não autorizado',
    },
    createRefund: {
      default_currency: '€',
      createRefund_timeoutError: 'O tempo de espera foi excedido',
      createRefund_timeoutTryLater:
        'Por favor verique mais tarde se o seu pedido de reembolso foi submetido.',
      createRefund_title: 'Reembolso',
      createRefund_picInstructions:
        'Tire fotografias de todas as páginas da fatura ou selecione na sua galeria de imagens.',
      createRefund_selectPatient: 'Selecione o paciente',
      createRefund_continue: 'Continuar',
      createRefund_readingInProgress: 'Leitura em progresso',
      createRefund_popupConfirm: 'Ok',
      createRefund_errorOnReading: 'Houve um problema na leitura da fatura',
      createRefund_tryLater: 'Por favor tente mais tarde',
      createRefund_readingComplete: 'Leitura completa',
      createRefund_readingCompleteDescription:
        'Confirme os dados recolhidos no ecrã seguinte',
      createRefund_confirmSend: 'Confirmar e enviar',
      createRefund_confirmDataDescription:
        'Confirme os dados preenchidos antes de enviar o pedido.',
      createRefund_occurenceDate: 'Data da ocorrência',
      createRefund_seeInvoice: 'Ver Fatura',
      createRefund_removeInvoiceTitle: 'Deseja Continuar?',
      createRefund_removeInvoiceDescription:
        'Ao continuar perderá as informações preenchidas e iniciará um novo pedido de reembolso.',
      createRefund_removeInvoiceYes: 'Sim',
      createRefund_removeInvoiceNo: 'Não',
      createRefund_selectFilesText:
        'Arraste o documento para esta área, ou procure no seu dispositivo',
      createRefund_selectFilesButtonText: 'Selecionar ficheiro',
      createRefund_successSendTitle: 'Enviado com sucesso',
      createRefund_successSendText:
        'Pode consultar os detalhes na lista de pedidos de reembolso',
      createRefund_successSendButton: 'Ok',
      createRefund_checkboxClinicDocuments:
        'Não tenho os documentos de informação clínica ou já anexei junto a fatura.',
      createRefund_checkboxNotUsingDocuments1:
        'Comprometo-me a não utilizar os documentos originais das despesas para outra finalidade. Em caso de participação prévia desta(s) despesa(s) a uma outra entidade/seguradora, manterei na minha posse o documento comprovativo dos valores já recebidos.',
      createRefund_checkboxNotUsingDocuments2:
        'Tomei conhecimento que a Seguradora se responsabilizará por declarar o valor das despesas para efeitos de IRS, caso cumpra todos os requisitos exigidos para o efeito na legislação em vigor, podendo nesse caso ser consultadas no Portal das Finanças.*',
      createRefund_mandatoryField: '(*) preenchimento obrigatório',
      createRefund_refundRequest: 'Pedido de reembolso',
      createRefund_confirm: 'Confirmar',
      createRefund_notification:
        'Enviaremos uma notificação quando a leitura terminar.',
      createRefund_patient: 'Paciente',
      createRefund_invoice: 'Fatura',
      createRefund_data: 'Dados',
      createRefund_leaveRequest: 'Sair do pedido',
      createRefund_hoursToPayment: 'Receba o pagamento até 72h úteis',
      createRefund_sendReceiptText: 'Para continuar envie-nos a fatura',
      createRefund_moreDocumentstext: 'Tem mais documentos?',
      createRefund_selectFilesConfirmAndSendButtonText: 'Continuar e enviar',
      createRefund_coverage: 'Cobertura',
      createRefund_medicalAct: 'Ato Médico',
      createRefund_value: 'Valor',
      createRefund_process: 'Processo',
      createRefund_clientValue: 'A cargo do cliente',
      createRefund_reimbursementValue: 'Valor reembolsado',
      createRefund_totalValue: 'Valor Total',
      createRefund_confirmData: 'Por favor confirme os seguintes dados',
      createRefund_confirmDataResponsive: 'Confirme os seguintes dados',
      createRefund_invalidValue:
        'Por favor verifique o campo, o valor deve ser maior que 0.00€.',
      createRefund_invalidInput: 'Este campo é obrigatório.',
      createRefund_addInformation: 'Adicionar Informações da fatura',
      createRefund_clinicInfo: 'Informação Clínica',
      createRefund_addClinicInfo: 'Anexar informação clínica',
      createRefund_addClinicInfoTitle:
        'Incluir nota de alta, protocolo operatório, relatório médico e resultados de exames realizados',
      createRefund_checkConsent:
        'Comprometo-me a não utilizar os documentos originais das despesas para outra finalidade. Em caso de participação prévia desta(s) despesa(s) a uma outra entidade/seguradora, manterei na minha posse o documento comprovativo dos valores já recebidos.',
      createRefund_checkConsentEnd:
        'Tomei conhecimento que a Seguradora se responsabilizará por declarar o valor das despesas para efeitos de IRS, caso cumpra todos os requisitos exigidos para o efeito na legislação em vigor, podendo nesse caso ser consultadas no Portal das Finanças.',
      createRefund_requiredFields: '(*) preenchimento obrigatório',
      createRefund_sent: 'Enviado com sucesso!',
      createRefund_documentsAvailable: 'Documentos disponíveis',
      createRefund_inProgress: 'Em progresso...',
      createRefund_errorOccurred: 'Ocorreu um erro.',
      createRefund_date_limit: 'A Data de Ocorrência deve ser posterior a 1998',
      createRefund_date_limit_exact: '1998/01/01',
      createRefund_include: 'Incluir ',
      createRefund_anexed_documents: 'Ficheiros anexados',
      refund_inactive_functionality:
        'A sua seguradora não tem acesso à submissão de reembolsos',
      createRefund_iban: 'IBAN para reembolso',
      createRefund_know_more: 'Saber mais',
      createRefund_know_more_modal_text:
        'O pagamento do reembolso será efetuado para o IBAN que estiver registado na data de emissão do pagamento. O IBAN pode ser alterado pelo titular da apólice em Seguros > Os meus dados.',
      createReufund_know_more_modal_ok: 'Compreendi',
      createRefund_step3_notTitular:
        'Para reembolso em 72h solicite ao titular da apólice que preencha o IBAN',
      createRefund_step3_titular: 'Para reembolso em 72h, preencha o seu IBAN ',
      refund_alert_owner_1: 'Para reembolso em 72h, preencha o seu IBAN ',
      refund_alert_owner_2: 'aqui',
      refund_alert_not_owner:
        'Para reembolso em 72h solicite ao titular da apólice que preencha o IBAN',
      delete_all_documents: 'Apagar documentos',
      delete_document: 'Apagar documento',
      createRefund_refundDateFormat: 'DD.MM.AAAA',
      createRefund_postTimeOut: '29',
      createRefund_picInstructionsWithPreComparticipation: 'Tire fotografia a',
      createRefund_picInstructionsWithPreComparticipationUnderlined:
        'apenas uma fatura',
      createRefund_picInstructionsWithPreComparticipation2:
        'ou seleciona na sua galeria de imagens.',
      createRefund_picInstructionsPreComparticipationDeclaration:
        'Tire fotografias à',
      createRefund_picInstructionsPreComparticipationDeclarationUnderlined:
        'declaração de comparticipação',
      createRefund_picInstructionsPreComparticipationDeclaration2:
        'ou selecione na sua galeria de imagens.',
      createRefund_picInstructionsClinicalInformation: 'Tire fotografias aos',
      createRefund_picInstructionsClinicalInformationUnderlined:
        'documentos de informação clínica',
      createRefund_picInstructionsClinicalInformation2:
        'ou selecione na sua galeria de imagens.',
      createRefund_preComparticipationQuestion:
        'Esta fatura já foi comparticipada por outra entidade, através de reembolso ou copagamento no prestador?',
      createRefund_preComparticipationQuestionYes: 'Sim',
      createRefund_preComparticipationQuestionNo: 'Não',
      createRefund_preComparticipationAttachmentsTitle: 'Anexar declaração',
      createRefund_preComparticipationAttachments1: 'Adicione a',
      createRefund_preComparticipationAttachmentsHighlighted:
        'declaração de comparticipação',
      createRefund_preComparticipationAttachments2:
        'emitida pela outra entidade de saúde.',
      createRefund_preComparticipationAttachmentsCheckbox:
        'Não tenho declaração. A fatura serve de comprovativo.',
      createRefund_selectFilesText_browser_1:
        'Arraste o documento para esta área, ou',
      createRefund_selectFilesText_browser_2: 'selecione o ficheiro.',
      createRefund_include_prescription:
        'Incluir prescrição médica ou guia de tratamento',
      createRefund_preComparticipationDialogSubtitle:
        'Deve solicitar o documento à entidade de saúde que pagou parte desta despesa.',
      createRefund_preComparticipationDescription:
        'Paga através do pedido de reembolso ou copagamento.',
      createRefund_know_more_modal_text_ibanEnabled_owner:
        'O IBAN pode ser alterado pelo titular da apólice em Seguro > Os meus dados > IBAN para reembolsos.',
      createRefund_know_more_modal_text_ibanEnabled_not_owner:
        'O IBAN pode ser alterado pelo titular da apólice em Seguro > Os meus dados > IBAN para reembolsos.',
      createRefund_know_more_modal_text_ibanDisabled_owner:
        'Contacte a sua Seguradora para atualizar o seu IBAN',
      createRefund_know_more_modal_text_ibanDisabled_not_owner:
        'Contacte a sua Seguradora para atualizar o seu IBAN',
      createRefund_step3_owner: 'Para reembolso em 72h, preencha o seu IBAN ',
      createRefund_step3_not_owner:
        'Para reembolso em 72h solicite ao titular da apólice que preencha o IBAN',
    },
    changePassword: {},
    myData: {
      myData_title: 'Os meus dados',
      myData_subTitle: 'Verifique os dados do segurado',
      myData_fullName: 'Nome Completo',
      myData_dateOfBirth: 'Data de Nascimento',
      myData_gender: 'Género',
      myData_fiscalNumber: 'Número de Identificação Fiscal',
      myData_address: 'Morada',
      myData_phone: 'Telefone',
      myData_cellphone: 'Telemóvel',
      myData_cellphone_show: '1',
      myData_email: 'E-Mail',
      myData_incorrectData: 'Algum dos dados está incorreto?',
      myData_myProfile: 'O meu perfil',
      myData_iBANReimbursement: 'IBAN para reembolsos',
      myData_contact: 'Contate a Tranquilidade',
      myData_iBANTitle:
        'Aqui pode informar a AdvanceCare de um novo IBAN, para pagamento exclusivo das despesas de saúde ou alterar o IBAN já comunicado.',
      myData_iBAN: 'IBAN',
      myData_iBANOwner: 'Titular da conta',
      myData_iBANCheckboxText:
        'Confirmo que sou o titular desta conta bancária',
      myData_iBANEnd:
        'A informação recolhida não será transmitida à sua seguradora ou subsistema, pelo que não será utilizada para cobrança, estorno de prémios ou mensalidades de plano de saúde.',
      myData_myProfile_underText: 'Ver e editar os dados de registo',
      myData_iBANReimbursement_underText: 'Ver e editar IBAN para Reembolsos',
      myData_pageTitle: 'Dados do Segurado',
      myData_iBANSave: 'Gravar',
      myData_contactNumber: '213 228 000',
      myData_noPermission:
        'Requer permissão para visualizar e gerir a informação da pessoa selecionada. Para ter permissão a pessoa selecionada deverá dar permissão na sua conta do portal na área Permissões.',
      myData_cantSubmit_iBANEnd:
        'Para alteração do IBAN solicitar ao titular da sua conta',
      myData_passwordCheck1: 'Olá',
      myData_passwordCheck2:
        ', para ver ou editar o IBAN para os reembolsos insira a sua palavra-passe.',
      myData_password_error: 'A palavra-passe introduzida não é válida',
      myData_dataUpdateSuccessMessage: 'Dados alterados com successo',
      myData_bankAccountDataExpanded: '1',
      myData_insuranceDataExpanded: '1',
      myData_InternacionaIbanDataDisplay: 'true',
      myData_IntBankAccountDataHeader: 'Bank Account Data',
      myData_IntInsuranceDataHeader: 'Insurance Data',
      myData_IntBankAccountDataSubtitle:
        'Generalis uses this bank account data exclusively to pay for healthcara expenses',
      myData_IntBankAccountDataFromSerbia: 'Do you reside in Serbia?',
      myData_IntBankAccountDataAccountNumber: 'Bank Account Number',
      myData_IntBankAccountDataAccountHolder: 'Bank Account Holder',
      myData_IntBankAccountDataAccountHolderAddress: 'Account Holder Address',
      myData_IntBankAccountDataCountry: 'Country of Residence',
      myData_Yes: 'Yes',
      myData_No: 'No',
      myData_invalidIBAN: 'Invalid IBAN',
      myData_invalidBankAccountNumber: 'Invalid Bank Account Number',
      myData_confirm: 'Confirm',
      myData_mandatoryField: 'Mandatory Field',
    },
    ibanRefunds: {
      ibanRefundstitle: 'IBAN para reembolsos',
      ibanRefundstext:
        'Aqui pode informar a AdvanceCare de um novo IBAN, para pagamento exclusivo das despesas de saúde ou alterar o IBAN já comunicado.',
      ibanRefundsiban: 'IBAN',
      ibanRefundsaccountHolder: 'Titular da conta',
      ibanRefundsinfo:
        'A informação recolhida não será transmitida à sua seguradora ou subsistema, pelo que não será utilizada para cobrança, estorno de prémios ou mensalidades de plano de saúde.',
      ibanRefundssave: 'Gravar',
      ibanRefundsibanChanged: 'IBAN para reembolso alterado',
      ibanRefunds_ibanIsEnabled: '1',
      ibanRefunds_bankAccountDataHolder: 'INDIVIDUAL',
      ibanRefunds_bankAccountDataRequiredForRefunds: '1',
      ibanRefunds_fillIbanMyData: 'Preencha o seu IBAN',
      ibanRefunds_fillIbanMyDataLink: 'aqui',
      ibanRefunds_fillIbanAskTitular:
        'Solicite ao titular da apólice que preencha o IBAN.',
      ibanRefunds_fillIbanAskInsuranceCompany:
        'Contacte a sua Seguradora para atualizar o seu IBAN.',
      ibanRefunds_usePermissions: '1',
      ibanRefunds_form: ' ',
      ibanRefunds_fillIbanAskInsuranceCompanyNotOwner:
        'Contacte a sua Seguradora para atualizar o seu IBAN.',
      ibanRefunds_ibanEnabled_owner: 'vazio',
      ibanRefunds_ibanEnabled_not_owner:
        'Para adicionar ou alterar o IBAN, solicitar ao titular da apólice',
      ibanRefunds_ibanDisabled_ibanRequired_owner: 'vazio',
      ibanRefunds_ibanDisabled_ibanRequired_not_owner:
        'Contacte a sua Seguradora para atualizar o seu IBAN',
    },
    mais: {},
    pedidos: {},
    rede: {
      default_currency: '€',
      medicalNetwork_title: 'Rede Médica',
      medicalNetwork_subtitle1:
        'Encontre o que precisa e saiba logo quanto vai pagar.',
      medicalNetwork_subtitle2:
        'Em Portugal, Espanha e EUA com 129 especialistase 16000 prestadores.',
      medicalNetwork_search: 'O que procura?',
      medicalNetwork_district_county: 'Concelho ou Distrito',
      medicalNetwork_local: 'Localidade',
      medicalNetwork_all_networks: 'Todas as redes selecionadas',
      medicalNetwork_selected_networks: 'Redes selecionadas',
      medicalNetwork_spain_network: 'Rede em Espanha',
      medicalNetwork_spainNetworkURL: 'https://www.advancecare.pt',
      medicalNetwork_search_suggestion: 'Sugestões de pesquisa',
      medicalNetwork_search_button: 'Pesquisar',
      medicalNetwork_selectNetwork_title: 'Selecione a rede',
      medicalNetwork_selectNetwork_all: 'Selecionar todas',
      medicalNetwork_selectNetwork_button: 'Continuar',
      medicalNetwork_results1: 'resultados para',
      medicalNetwork_results2: 'em',
      medicalNetwork_results3: 'todas as redes',
      medicalNetwork_resultDesc1: 'rede',
      medicalNetwork_resultDesc2: 'Redes',
      medicalNetwork_editSearch: 'Editar pesquisa',
      medicalNetwork_seeAll: 'ver todos',
      medicalNetwork_locations: 'locais',
      medicalNetwork_locations1: 'local',
      medicalNetwork_clinics: 'Hospitais e Clínicas',
      medicalNetwork_medics: 'Médicos',
      medicalNetwork_suggestion: 'Sugestões de pesquisa',
      medicalNetwork_surgery: 'Cirugias',
      medicalNetwork_consults: 'Consultas',
      medicalNetwork_exams: 'Exames',
      medicalNetwork_optics: 'Óticas',
      medicalNetwork_wellBeing: 'Bem-Estar',
      medicalNetwork_popup_title: 'Disponibilidade da Rede Médica',
      medicalNetwork_popup_description1:
        'A disponibilidade dos prestadores pode variar de acordo com',
      medicalNetwork_popup_description2:
        'as condições do seu seguro ou plano de saúde',
      medicalNetwork_popup_ok: 'Compreendi',

      medicalNetwork_noResults_suggestion1: 'Neste momento ',
      medicalNetwork_noResults_suggestion2:
        'a pesquisa não obteve resultados. ',
      medicalNetwork_noResults_suggestion3: 'Sugestões:',
      medicalNetwork_suggestion4:
        '• Certifique-se de que todas as palavras estão escritas corretamente.\r\n • Limpe os filtros que aplicou à sua pesquisa.\r\n • Tente palavras-chave diferentes.\r\n • Tente usar menos palavras-chave.',
      medicalNetwork_noResults_goBack: 'Regressar',
      medicalNetwork_clinics_telephone: 'Tel:',
      medicalNetwork_clinics_email: 'E-mail:',
      medicalNetwork_clinics_website: 'Website:',
      medicalNetwork_didYouMean: 'Será que quis dizer:',
      medicalNetwork_clinics_speciality_noResults:
        'Consulte os médicos disponiveis com o prestador.',
      medicalNetwork_clinics_speciality_exams_noResults:
        'Consulte os exames disponiveis com o prestador.',

      medicalNetwork_medicOnlineBanner_keywords:
        'Urgência,Urgências,Clínica Geral,Pediatria,Atendimento Permanente,Covid,Consulta Online,Médico Online,Teleconsulta,Médico ao Domicílio,Pediátrico,Clínica Familiar,Medicina Familiar,Medicina Geral',
      medicalNetwork_clinics_speciality_noInfo: 'Sem informação disponível.',
      medicalNetwork_price_tooltip_title: 'Preço estimado',
      medicalNetwork_price_tooltip_description:
        'Os preços apresentados são uma estimativa do valor a pagar. A disponibilidade dos prestadores e preços podem variar de acordo com as condições do seu seguro ou plano de saúde.',
      medicalNetwork_toggleHeaders: 'true',
      medicalNetwork_clinicDetail_viewAllActsIn: 'Ver todos os atos em ',
      medicalNetwork_see_more: 'ver mais',
      medicalNetwork_see_less: 'ver menos',
      medicalNetwork_load_more: 'Carregar mais...',
      medicalNetwork_schedule_appointment_button: 'Marcar consulta',

      medicalNetwork_locations_view_map: 'Visualizar Mapa',
      medicalNetwork_locations_view_list: 'Visualizar Lista',
      medicalNetwork_locations_move_map_info:
        'Mova o mapa para ver mais resultados',
      medicalNetwork_locations_expand_map: 'Expandir Mapa',
      medicalNetwork_locations_shrink_map: 'Reduzir Mapa',
      medicalNetwork_locations_price_currency: '€',
      medicalNetwork_locations_view_details: 'Ver detalhes',
      medicalNetwork_locations_see_directions: 'Ver direções',
      medicalNetwork_functionality_try_again_later:
        'Neste momento não é possível aceder à funcionalidade selecionada. Por favor tente mais tarde.',
      medicalNetwork_filter_option_relevance: 'Relevância',
      medicalNetwork_filter_option_alphabetic: 'Ordem Alfabética',
      medicalNetwork_results_from: 'de',
      medicalNetwork_results: 'resultados',
      medicalNetwork_appointments_code: '2',
      medicalNetwork_exams_code: '1',
      medicalNetwork_surgery_code: '3',
      medicalNetwork_other_code: '4',
      medicalNetwork_show_all_appointments: 'Mostrar todas as consultas',
      medicalNetwork_show_all_exams: 'Mostrar todos os exames e tratamentos',
      medicalNetwork_inactiveCategories: '',
    },
    redePrecos: {
      medicalNetwork_show_price_appointment: '1',
      medicalNetwork_show_price_exam: '1',
      medicalNetwork_show_price_surgery: '1',
      medicalNetwork_show_price_other: '1',
      medicalNetwork_popup_estimated_price_description1:
        'Os preços apresentados são ',
      medicalNetwork_popup_estimated_price_description2: 'uma estimativa ',
      medicalNetwork_popup_estimated_price_description3:
        'do valor a pagar. A disponibilidade dos prestadores e preços podem variar de acordo com ',
      medicalNetwork_popup_estimated_price_description4:
        'as condições do seu seguro ou plano de saúde.',
    },
    seguro: {},
    start: {
      start_hello: 'Olá',
      start_dropLogout: 'Terminar Sessão',
    },
    services: {
      services_title: 'Os meus Serviços',
      services_subTitle: 'Mais serviços disponíveis',
      services_mainSubtitle: 'Os serviços da sua apólice',
      services_moreServicesAvailable: 'Mais serviços disponíveis',
      services_noServicesAvailable: 'Não há serviços disponíveis',
      services_error: 'Ocorreu um erro. Por favor tente mais tarde.',
      services_seeAll: 'Ver todos',
      services_mediktor_error:
        'Ocorreu um erro. Não é possível avaliar os seus sintomas. Por favor, tente mais tarde.',
    },
    myProfile: {
      myProfile_pageTitle: 'O meu Perfil',
      myProfile_title: 'MyAdvanceCare e AdvanceCare+',
      myProfile_emailLabel: 'Nome de utilizador / E-mail de registo',
      myProfile_changePassword: 'Alterar palavra-passe',
      changePassword_errorTitle2: 'Palavra-passe atual errada.',
      myProfile_touchId: 'Fazer Login com Touch ID',
      myProfile_nameLabel: 'Nome',
      myProfile_contactLabel: 'E-mail para contacto',
      myProfile_phoneNumberLabel: 'Nº Telemóvel',
      myProfile_button: 'Gravar',
      myProfile_dialogText: 'Dados do perfil alterados',
      myProfile_dialogButton: 'Ok',
      changePassword_pageTitle: 'O meu Perfil',
      changePassword_title: 'Alterar palavra-passe',
      changePassword_currentPasswordLabel: 'Palavra-passe atual',
      changePassword_newPasswordLabel: 'Nova palavra-passe',
      changePassword_confirmNewPasswordLabel: 'Repita a nova palavra-passe',
      changePassword_underText:
        'A palavra-passe também será alterada no AdvanceCare+',
      changePassword_button: 'Alterar',
      changePassword_errorTitle: 'As Palavras-passe não coincidem.',
      changePassword_errorText: 'Por favor verifique.',
      changePassword_passwordError:
        'Insira uma palavra-passe com pelo menos uma maiúscula, um número e oito caracteres',
      myProfile_saveSucceeded: 'Dados do perfil alterados',
      myProfile_saveFailed: 'A informação do perfil não pode ser alterada',
      myProfile_oldPasswordError: 'A palavra-passe atual está incorreta',
      myProfile_nameValidationError:
        'Por favor introduza exatamente 1 nome e 1 apelido!',
      myProfile_dataOfRegister:
        'Os seus dados de registo do MyAdvanceCare e AdvanceCare+',
      myProfile_updateEmail: 'Quer atualizar o seu e-mail? ',
      myProfile_newRegister: 'Faça novo registo.',
    },
    permissions: {
      permissions_title: 'Permissões',
      permissions_subtitle:
        'Para gerir as suas permissões, selecione uma das opções:',
      permissions_advancecare_title: 'AdvanceCare',
      permissions_myinsurance_title: 'O meu seguro',
      permissions_advplus_title: 'AdvanceCare+',
      permissions_allowed: 'Autorizado a',
      permissions_where: 'no',
      permissions_myAdv: 'myAdvanceCare',
      permissions_advPlusAlertText1:
        'O AdvanceCare+ depende do tratamento desta informação. Sem o seu consentimento não será possível prosseguir com o registo. Para mais informações clique',
      permissions_continueQuestion: 'Deseja continuar?',
      permissions_advPlusAlertText2:
        'O tratamento de dados de saúde é indispensável à utilização do AdvanceCare+.Ao retirar o seu consentimento, perderá acesso à mesma.',
      permissions_yes: 'Sim',
      permissions_no: 'Não',
      permissions_readingError: 'Ocorreu um erro, por favor tente mais tarde',
      permissions_subtitleInsuranceOnHand:
        'A informação sobre o seu seguro sempre à mão',
      permissions_descriptionInsuranceOnHand:
        'Ao aderir está também a contribuir para um planeta mais saudável, já que passaremos a enviar-lhe a comunicação relativa à utilização do seu seguro ou plano de saúde via digital. Após concordar, o envio digital ficará ativo no decorrer dos dias seguintes, ficando toda a informação disponível no myAdvanceCare. Para saber mais sobre estas comunicações, ',
      permissions_clickOnHereInsuranceOnHand: 'aceda aqui.',
      permissions_agreeInsuranceOnHand: 'Concordo',
      permissions_subtitleAuthorizationThirdParties:
        'Declaração de Autorização a Terceiros',
      permissions_descriptionAuthorizationThirdParties1:
        'Autorizo as pessoas seguras indicadas',
      permissions_clickOnAuthorizationThirdParties: 'aqui',
      permissions_descriptionAuthorizationThirdParties2:
        'a praticarem os atos abaixo indicados, em meu nome e representação, no âmbito do seguro [identificar o seguro], bem como a aceder a todos os meus dados pessoais, incluindo dados de saúde, através dos canais telefónico e digital/myAdvanceCare, com as seguintes finalidades: • Apresentar pedidos de reembolsos/submissão de despesas. • Submeter pedidos de pré-autorização. • Apresentar reclamações. • Submeter pedidos de informação. • Apresentar sugestões. Esta Declaração é valida enquanto vigorar a Apólice/Plano de saúde. Caso pretenda, poderá retirar a autorização a qualquer momento, editando as suas preferências.',
      permissions_authAllowedTo: 'Autorização atribuída a',
      permissions_confirm: 'Confirmar',
      permissions_button_ok: 'Ok',
      permissions_clinic_title: 'Autorização para Médico Online',
      permissions_clinic_checkbox_text:
        'Autorizo que a AdvanceCare e os seus subcontratantes, tratem dos meus dados de saúde, de atividade física, hábitos alimentares entre outros consumos, para a utilização desta aplicação e respetivas atividades conexas, tais como o cálculo do índice de bem-estar, recomendações, participação em desafios e obtenção de recompensas. Mais informações',
      permissions_advancecare_active: '1',
      permissions_myinsurance_active: '1',
      permissions_myinsurance_checkbox_insuranceinyourhands: '1',
      permissions_myinsurance_checkbox_thirdpartypermissions: '1',
      permissions_not_allowed_to_manage: 'Não tem permissões para gerir',
    },

    quickGuide: {},
    talkWithUs: {
      talkWithUs_title: 'Fale connosco',
      talkWithUs_subtitle:
        'Esclareça as suas dúvidas de forma prática e rápida.',
      talkWithUs_reason: 'Motivo *',
      talkWithUs_mandatory: '(*) preenchimento obrigatório',
      talkWithUs_injured: 'Lesado *',
      talkWithUs_injuredEmail: 'E-mail para contacto *',
      talkWithUs_invalidEmail: 'Email inválido',
      talkWithUs_complaintTarget: 'Alvo da reclamação *',
      talkWithUs_providerTitle: 'Indique o nome ou o NIF do prestador',
      talkToUs_nameOrNif: 'Nome ou NIF do prestador',
      talkWithUs_button: 'Enviar',
      talkWithUs_searchButton: 'Pesquisar',
      talkWithUs_complaint: 'Reclamação*',
      talkWithUs_documents: 'Anexar documentos',
      talkWithUs_successPopUpTitle: 'Enviado com sucesso',
      talkWithUs_successPopUptext:
        'Enviaremos uma notificação com resposta ao seu contacto',
      talkWithUs_successPopUpButton: 'Ok',
      talkWithUs_select: 'Selecionar',
      talkWithUs_selectFile: 'Selecionar ficheiro',
      talkWithUs_selectFileDescription:
        'Se tiver um documento para anexar por favor arraste-o para esta área, ou procure no seu dispositivo.',
      talkWithUs_understood: 'Compreendi',
      talkWithUs_searchProvider: 'Pesquisar prestador *',
      talkWithUs_reasonPlaceholder: 'Selecione',
      talkWithUs_complaintTargetPlaceholder: 'Selecione o alvo da reclamação',
      talkWithUs_providerPopUpButton: 'Confirmar',
      talkWithUs_providerIdentificationPlaceholder:
        'Insira o nome ou NIF do prestador',
      talkWithUs_complaintPlaceholder: 'Insira a sua mensagem',
      talkWithUs_providerPopUpTitle: 'Selecione o prestador',
      talkWithUs_providerName: 'Nome',
      talkWithUs_providerNamePlaceholder: 'Pesquise por nome do prestador',
      talkWithUs_providerNIF: 'NIF',
      talkWithUs_providerNIFPlaceholder: 'Pesquise por nif do prestador',
      talkWithUs_provider: 'Prestador *',
      talkWithUs_emptyList: 'Por favor, redefina a sua pesquisa.',
      talkWithUs_providerEmail: 'E-mail',
      talkWithUs_InvalidSearch: 'Pesquisa invalida',
      talkWithUs_InvalidSearchLabel: 'Por favor, redefina a sua pesquisa',
      talkWithUs_FailedSubmit: 'Ocorreu um erro ao submeter o seu pedido',
      talkWithUs_FailedSubmitSubtext: 'Por favor, tente outra vez',
      talkWithUs_message: 'Mensagem',
      talkWithUs_document: 'Documento',
      talkWithUs_whatsappTitle:
        'Entre em contacto connosco através do whatsapp',
      talkWithUs_chatbotTitle: 'ou da assitente virtual AdvanceCare.',
      talkWithUs_whatsappButtonTitle: 'Fale connosco',
      talkWithUs_whatsappButtonSubitle: 'no Whatsapp',
      talkWithUs_whatsappLink: 'https://wa.me/351933228628',
      talkWithUs_chatbotButtonTitle: 'Assistente Virtual',
    },
    frequentQuestions: {
      faqs_title: 'Perguntas frequentes',
      faqs_error: 'Ocorreu um erro, por favor tente mais tarde',
    },
    privacyPolicy: {},
    personalDataProtection: {},
    termsConditions: {},
    footer: {
      legalInformation: 'Informações legais',
      help: 'Ajuda',
      settings: 'Definições',
      copyright: 'Copyright 2020 © Todos os direitos reservados.',
      version: 'Versão',
      termsConditions: 'Termos e Condições',
      protectionPersonalData: 'Proteção de Dados Pessoais',
      privacyPolicy: 'Politicas de privacidade',
      commonQuestions: 'Perguntas Frequentes',
      talkToUs: 'Fale Connosco',
      quickGuide: 'Guia Rápido',
      myProfile: 'O meu Perfil',
      permissions: 'Permissões',
      clientGuide: 'Guia do Cliente',
      clientGuidePDF: 'www.google.pt',
      dowload_app: 'Descarregue a nossa app myAdvanceCare',
      appDownloadVisible: '1',
    },
    generalConditions: {},
    myCoverages: {
      unlimited: 'Ilimitado',
      show_policy_number: 'true',
      generalPolicyConditions: 'Condições Gerais da Apólice - URL',
      myCovers: 'As minhas coberturas',
      policyNumber: 'Nº da apólice',
      policy: 'Apólice',
      policyGeneralConditions:
        'Consulte todas as condições gerais da sua apólice.',
      policyHolderName: 'Titular da apólice',
      cover: 'Cobertura',
      coverConditions: 'Condições da cobertura',
      insideNetwork: 'Dentro da rede',
      outsideNetwork: 'Fora da rede',
      franchise: 'Franquia',
      coverages_subtitle: 'Verifique a utilização das suas coberturas',
      documents: 'Documentos',
      limit: 'Limite de consultas',
      readingError: 'Ocorreu um erro. Tente mais tarde.',
      recentCoverages: 'As últimas coberturas utilizadas',
      seeAll: 'Ver todas',
      covers: 'Coberturas',
      listType: 'PDF',
      pdfUrl: 'https://www.advancecare.pt/pdfs/Guia.pdf',
      conditions_limits: 'Condições e limites da cobertura',
      client_responsibility: 'A cargo do cliente:',
      inside_network: 'Dentro da rede',
      outside_network: 'Fora da rede',
      appointment_limit: 'Limite',
      deduct: 'Franquia:',
      coverDeductType: 'Tipo de franquia',
      currency: '€',
      default_currency: '€',
      noDetail_title:
        'De momento não existem dados disponíveis para esta cobertura.',
      noDetail_message: 'Por favor tente mais tarde.',
      noDetail_button: 'Ok',
      until: 'até',
      endPageNote:
        '(*) definição genérica, não dispensa a consulta das condições definidas no seu seguro/plano de saúde.',
      error_fetching:
        'Não foi possível obter a informação. Tente novamente mais tarde',
    },
    register: {
      'pt-PT': 'Português (PT)',
      'pt-BR': 'Português (BR)',
      'en-US': 'English (EN)',
      'rs-RS': 'Engleski (RS)',
      en: 'Inglês (EN)',
      register_multi_language_info:
        'O idioma pode ser alterado em qualquer momento na página inicial.',
      contactActivation_headerTitle: 'Registo',
      contactActivation_title: 'Ativação do registo',
      contactActivation_subTitle:
        'Escolha um dos contactos identificados abaixo para receber o código de ativação.',
      contactActivation_underText:
        'Caso os contactos apresentados estejam incorretos, ou não tenha acesso aos mesmos neste momento,',
      contactActivation_linkText: 'clique aqui.',
      contactActivation_buttonText: 'Confirmar',
      activation_headerTitle: 'Registo',
      activation_title: 'Ativação do Registo',
      activation_subTitle: 'Insira o código de ativação enviado para',
      activation_activationCodePlaceholder: 'Código de ativação',
      activation_buttonText: 'Ativar Registo',
      register_headerExitLabel: 'Sair',
      register_nifError: 'Este campo tem de ter no minimo 9 digitos',
      register_underAgeDialogTitle:
        ' O utilizador menor não pode aderir ao myAdvanceCare.',
      register_underAgeDialogText:
        ' O registo deve ser efetuado por quem tem responsabilidade parental. Caso pretenda associar o seguro ou plano de saúde, o registo deve ser efetuado pelo subscritor da apólice.',
      register_underAgeDialogConfirmButton: 'Ok',
      register_pageTitle: 'Bem-vindo!',
      register_multi_language_pageTitle: 'Definição de idioma',
      register_pageSubTitle:
        'Preencha os dados abaixo para verificarmos se é um utilizador com ou sem seguro de saúde de um dos nossos parceiros.',
      register_namePlaceholder: 'Nome e Apelido',
      register_nifPlaceholder: 'NIF',
      register_nifInfo:
        'Informação necessária para verificarmos os seus produtos',
      register_birthdayPlaceholder: 'Data de Nascimento',
      register_termsAndConditionsInit: 'Li, compreendi e aceito os',
      register_termsAndConditionsLink: 'Termos e Condições',
      register_privacyInit: 'Li, compreendi e aceito a',
      register_privacyLink:
        ' Política de Tratamento de Dados Pessoais do MyAdvanceCare',
      register_confirmButton: 'Continuar',
      register_beforeContinueCheckbox1Link: 'meu perfil.',
      register_usernameAlreadyRegistered:
        'O e-mail de registo introduzido já existe. Por favor utilize outro endereço de e-mail.',
      register_wrongActivationCode: 'O código de ativação inserido está errado',
      register_invalidCredentials: 'As credenciais que colocou não são válidas',
      register_nameValidationError:
        'Por favor introduza exatamente 1 nome e 1 apelido!',
      register_minAge: '16',
      emailAndPassword_title: 'Registo',
      emailAndPassword_pageTitle: 'Dados de registo',
      emailPassword_existingUsername: 'O email inserido já está registado',
      emailAndPassword_pageSubTitle:
        'Defina um email e uma palavra-passe para concluir o seu registo',
      emailAndPassword_emailPlaceholder: 'Email',
      emailAndPassword_passwordPlaceholder: 'Palavra-passe',
      emailAndPassword_confirmPasswordPlaceholder:
        'Confirme a sua palavra-passe',
      emailAndPassword_button: 'Finalizar registo',
      emailAndPassword_emailError: 'O formato do email está errado',
      emailAndPassword_passwordError:
        'Insira uma palavra-passe com pelo menos uma maiúscula, um número e oito caracteres',
      emailAndPassword_confirmPasswordError: 'As palavras-passe não coincidem',
      emailPassword_emailRequired: 'Defina um email',
      emailPassword_emailError: 'Insira um email válido',
      insuranceAndPhone_title: 'Registo',
      insuranceAndPhone_pageTitle: 'Activação do registo',
      insuranceAndPhone_pageSubTitle:
        'Para ter acesso completo às funcionalidades do myAdvanceCare, indique-nos:',
      insuranceAndPhone_insuranceNumberPlaceholder:
        'Número do cartão do seguro',
      insuranceAndPhone_didntReceivedQuestion:
        'Ainda não recebeu o cartão de saúde?',
      insuranceAndPhone_didndReceivedText: 'Não tenho o cartão do meu seguro',
      insuranceAndPhone_phoneNumberPlaceholder: 'Telemóvel',
      insuranceAndPhone_sendCodeText:
        'Enviaremos o código de ativação,por SMS para o número inserido neste campo.',
      insuranceAndPhone_confirmButtonText: 'Confirmar',
      registerComplete_headerTitle: 'Registo',
      registerComplete_title: 'Obrigado!',
      registerComplete_title2: 'Registo Finalizado',
      registerComplete_previousClientText:
        'A partir de agora já pode entrar no myAdvanceCare e no AdvanCare+ com o mesmo Login.',
      registerComplete_comunText:
        'A partir de agora já pode entrar no myAdvanceCare.',
      registerComplete_noInsuranceText:
        'Vá ao seu e-mail e ative a sua conta para fazer login',
      registerComplete_buttonText: 'Fazer Login',
      register_beforeContinueButtonText: 'Continuar',
      register_beforeContinueTitle: 'Antes de continuar',
      register_beforeContinueSubtitle1:
        'Quer receber as nossas comunicações de marketing?',
      register_beforeContinueCheckbox1Text:
        'Autorizo a AdvanceCare a tratar os meus dados para efeitos de comunicações de produtos e serviços próprios e outras comunicações comerciais, efetuadas através dos canais disponíveis (e-mail, SMS, telefone, apps ou presencial). Estas comunicações podem ter em linha de conta os meus interesses e preferências, apuradas com base no',
      register_beforeContinueSubtitle2:
        'Quer receber conselhos de prevenção e saúde?',
      register_beforeContinueCheckbox2Text1:
        'Autorizo a AdvanceCare a tratar os meus dados para criação do ',
      register_beforeContinueCheckbox2Link: 'meu perfil',
      register_beforeContinueCheckbox2Text2:
        ' de forma a receber comunicações personalizadas e de acordo com os meus interesses e preferências, sobre saúde e bem-estar ou conselhos de prevenção, efetuadas através dos canais disponíveis (e-mail, SMS, telefone, apps ou presencial).',
      activationChoice_title: 'Confirmação de dados',
      activationChoice_subTitle:
        'Através dos seus dados não encontrámos nenhum seguro/plano de saúde.',
      activationChoice_underText:
        'Por favor indique-nos se tem seguro/plano de saúde:',
      emailPassword_button: 'Continuar',
      insuranceAndPhone_didntReveceiveCard: 'Não tenho o cartão do meu seguro',
      registerComplete_canLogin:
        'A partir de agora já pode entrar no myAdvanceCare.',
      register_wantToRegister: 'Deseja registar-se?',
      register_noRegistsFound:
        'Não foi encontrado nenhum registo no myAdvanceCare com os dados inseridos.',
      register_yes: 'Sim',
      register_no: 'Não',
      register_step1: 'Verificação de seguro',
      register_myProfile_title: 'O meu perfil',
      register_myProfile_text:
        'A sua privacidade é um elemento fundamental na forma como pensamos e desenvolvemos os produtos e serviços da AdvanceCare.\r\nPorque a transparência no modo como tratamos os seus dados, é um dos principais alicerces deste compromisso, iremos agora explicar o que é a tomada de decisão automática e a definição de perfis, qual o seu papel no âmbito dos nossos produtos ou serviços e como beneficia deles enquanto utilizador.\r\nO Regulamento Geral sobre a Proteção de Dados (" RGPD"), apresenta as seguintes definições:\r\n• Decisões individuais automatizadas: quando são tomadas decisões sobre um indivíduo exclusivamente por meios automatizados;\r\n• Definição de perfis: avaliar determinados factos sobre um indivíduo, como seja comportamentos, interesses e preferências, através do tratamento de dados pessoais automatizado.\r\nEstes cenários verificam-se p.e quando se recorre apenas a computadores e algoritmos, para tomar decisões ou determinar os interesses de alguém, com base no seu comportamento.\r\nA AdvanceCare recorre à definição de perfis nas seguintes situações;\r\n• Para customizar a nossa oferta de produtos e serviços em linha com as suas preferências;\r\n• Para personalizar as comunicações que lhe iremos enviar sobre saúde e bem-estar.\r\nApresentamos sumariamente os critérios subjacentes à sua definição:\r\n• As suas preferências no My AdvanceCare e AdvanceCare+;\r\n• As cookies e experiência de navegação nos nossos sites e na Loja em particular;\r\n• As características do seu seguro de seguro e respetiva utilização;\r\nPara mais informações contactar:\r\n• encarregado.dados@advancecare.com',
      register_myProfile_link:
        'https://www.advancecare.pt/formularios/gestao-de-dados-pessoais#gestao-de-dados-pessoais=Contactar%20o%20encarregado%20de%20prote%C3%A7%C3%A3o%20de%20dados',
      register_myProfile_consent: 'Compreendi',
      permissions_titleHealthData: 'Autorização para dados de Saúde',
      permissions_descriptionHealthData:
        'Autorizo que a AdvanceCare e os seus subcontratantes , tratem os meus dados de saúde, de atividade física, hábitos alimentares entre outros consumos, para a utilização desta aplicação e respetivas atividades conexas, tais como o cálculo do índice de bem-estar, recomendações, participação em desafios e obtenção de recompensas. Mais informações ',
      permissions_moreInfoAdvPlus: 'aqui',
      permissions_TermosCondiçõesAdvPlusLink: 'https://www.advancecare.pt',
      errorUser_pageTitle: 'Este registo já existe!',
      errorUser_text1: 'Verificámos que fez um registo no AdvanceCare+.',
      errorUser_text2: 'Utilize estes dados para fazer login no myAdvanceCare.',
      activation_sendNewCode: 'Enviar novo código',
      activation_sendNewCode_sucess: 'Sucesso',
      activation_sendNewCode_sent: 'O novo código foi enviado',
      activationChoice_dropdownPlaceholder: 'Selecione a opção',
      activationChoice_NoInsuranceText: 'Não tenho seguro',
      activationChoice_OtherEntityText: 'Outra entidade',
      activationChoice_insuranceNumberPlaceholder: 'Número cartão seguro',
      activationChoice_cCPlaceholder: 'Cartão de Cidadão',
      language_selector: 'Selecionar idioma',
      changePassword_codeSent: 'O novo código foi enviado',
      register_before_continue_cmd_title: 'Antes de Continuar',
      register_account_data_cmd_title:
        'Indique o seu nome e apelido e defina um e-mail e uma palavra-passe para concluir o seu registo.',
    },

    registoCMD: {
      registoCMD_beforeContinueTitle: 'Antes de continuar...',
      registoCMD_beforeContinueSubtitle:
        'Pedimos que leia e aceite os nossos Termos e Condições e a nossa Política de Tratamento de Dados Pessoais. Os consentimentos para comunicações de marketing e prevenção podem ser geridos a partir dos dados de registo.',
      registoCMD_beforeContinueCheckbox1: 'Li, compreendi e aceito os',
      registoCMD_beforeContinueCheckbox1Url:
        ' Termos e Condições do myAdvanceCare',
      registoCMD_beforeContinueCheckbox1Link:
        ' Termos e Condições do myAdvanceCare',
      registoCMD_beforeContinueCheckbox2: 'Li, compreendi e aceito a',
      registoCMD_beforeContinueCheckbox2Link:
        ' Política de Tratamento de Dados Pessoais do myAdvanceCare',
      registoCMD_beforeContinueButton: 'Continuar',
      registoCMD_registerScreenTitle: 'Dados de registo',
      registoCMD_registerScreenSubtitle:
        'Indique o seu nome e apelido e defina um e-mail e uma palavra-passe para concluir o seu registo.',
      registoCMD_registerScreenButton: 'Finalizar registo',
      registoCMD_accountAlreadyExists: '',
      registoCMD_beforeContinueMarketingSubtitle:
        'Quer receber as nossas comunicações de marketing?',
      registoCMD_beforeContinueHealthSubtitle:
        'Quer receber conselhos de prevenção e saúde?',
      registoCMD_beforeContinueCheckbox1Text:
        'Autorizo a AdvanceCare a tratar os meus dados para efeitos de comunicações de produtos e serviços próprios e outras comunicações comerciais, efetuadas através dos canais disponíveis (e-mail, SMS, telefone, apps ou presencial). Estas comunicações podem ter em linha de conta os meus interesses e preferências, apuradas com base no',
      registoCMD_beforeContinueCheckbox1LinkMyProfile: ' meu perfil.',
      registoCMD_beforeContinueCheckbox2Text1:
        'Autorizo a AdvanceCare a tratar os meus dados para criação do',
      registoCMD_beforeContinueCheckbox2LinkMyProfile: ' meu perfil',
      registoCMD_beforeContinueCheckbox2Text2:
        ' de forma a receber comunicações personalizadas e de acordo com os meus interesses e preferências, sobre saúde e bem-estar ou conselhos de prevenção, efetuadas através dos canais disponíveis (e-mail, SMS, telefone, apps ou presencial).',
      registoCMD_myProfile_title: 'O meu perfil',
      registoCMD_myProfile_text:
        'A sua privacidade é um elemento fundamental na forma como pensamos e desenvolvemos os produtos e serviços da AdvanceCare.\r\nPorque a transparência no modo como tratamos os seus dados, é um dos principais alicerces deste compromisso, iremos agora explicar o que é a tomada de decisão automática e a definição de perfis, qual o seu papel no âmbito dos nossos produtos ou serviços e como beneficia deles enquanto utilizador.\r\nO Regulamento Geral sobre a Proteção de Dados (" RGPD"), apresenta as seguintes definições:\r\n• Decisões individuais automatizadas: quando são tomadas decisões sobre um indivíduo exclusivamente por meios automatizados;\r\n• Definição de perfis: avaliar determinados factos sobre um indivíduo, como seja comportamentos, interesses e preferências, através do tratamento de dados pessoais automatizado.\r\nEstes cenários verificam-se p.e quando se recorre apenas a computadores e algoritmos, para tomar decisões ou determinar os interesses de alguém, com base no seu comportamento.\r\nA AdvanceCare recorre à definição de perfis nas seguintes situações;\r\n• Para customizar a nossa oferta de produtos e serviços em linha com as suas preferências;\r\n• Para personalizar as comunicações que lhe iremos enviar sobre saúde e bem-estar.\r\nApresentamos sumariamente os critérios subjacentes à sua definição:\r\n• As suas preferências no My AdvanceCare e AdvanceCare+;\r\n• As cookies e experiência de navegação nos nossos sites e na Loja em particular;\r\n• As características do seu seguro de seguro e respetiva utilização;\r\nPara mais informações contactar:\r\n• encarregado.dados@advancecare.com',
      registoCMD_myProfile_link:
        '• https://www.advancecare.pt/formularios/gestao-de-dados-pessoais#gestao-de-dados-pessoais=Contactar%20o%20encarregado%20de%20prote%C3%A7%C3%A3o%20de%20dados',
      registoCMD_myProfile_consent: 'Compreendi',
      registoCMD_errorUser_pageTitle: 'Este registo já existe!',
      registoCMD_errorUser_text1:
        'Verificámos que fez um registo no myAdvanceCare.',
      registoCMD_errorUser_text2: 'Utilize estes dados para fazer login.',
      registoCMD_errorUser_buttonText: 'Fazer Login',
      registoCMD_activation_headerTitle: 'Registo',
      registoCMD_registerData: 'Dados de registo',
      registoCMD_registerDataSubtitle:
        'Indique o seu nome e apelido e defina um e-mail e uma palavra-passe para concluir o seu registo.',
      registoCMD_registerFullNamePlaceholder: 'Nome e apelido',
      registoCMD_underAgeDialogTitle:
        ' O utilizador menor não pode aderir ao myAdvanceCare.',
      registoCMD_underAgeDialogText:
        ' O registo deve ser efetuado por quem tem responsabilidade parental. Caso pretenda associar o seguro ou plano de saúde, o registo deve ser efetuado pelo subscritor da apólice.',
      registoCMD_underAgeDialogConfirmButton: 'Ok',
      registoCMD_emailPassword_existingUsername:
        'O email inserido já está registado',
      registoCMD_activation_subTitle:
        'Insira o código de ativação enviado para',
      registoCMd_activation_activationCodePlaceholder: 'Código de ativação',
      registoCMD_wrongActivationCode:
        'O código de ativação inserido está errado',
      registoCMD_usernameAlreadyRegistered:
        'O e-mail de registo introduzido já existe. Por favor utilize outro endereço de e-mail.',
      registoCMD_invalidCredentials:
        'As credenciais que colocou não são válidas',
      registoCMD_changePassword_codeSent: 'O novo código foi enviado',
      registoCMD_activation_sendNewCode: 'Enviar novo código',
      registoCMD_nameValidationError:
        'Por favor introduza exatamente 1 nome e 1 apelido!',
      registoCMD_emailAndPassword_passwordPlaceholder: 'Palavra-passe',
      registoCMD_emailAndPassword_emailPlaceholder: 'Email',
      registoCMD_emailAndPassword_confirmPasswordPlaceholder:
        'Confirme a sua palavra-passe',
      registoCMD_emailPassword_emailError: 'Insira um email válido',
      registoCMD_emailAndPassword_passwordError:
        'Insira uma palavra-passe com pelo menos uma maiúscula, um número e oito caracteres',
      registoCMD_activation_buttonText: 'Ativar Registo',
      registoCMD_cmdRegisterUrl:
        'https://preprod.autenticacao.gov.pt/oauth/askauthorization?redirect_uri=https://myadv-web-uat.azurewebsites.net/registoCMD&client_id=6167746956526857902&scope=http://interop.gov.pt/MDC/Cidadao/NomeProprio%20http://interop.gov.pt/MDC/Cidadao/DataNascimento%20http://interop.gov.pt/MDC/Cidadao/NIF&response_type=token&state=polarisingpt-PT',
      registoCMD_multi_language_info:
        'O idioma pode ser alterado em qualquer momento na página inicial.',
      registoCMD_contactActivation_buttonText: 'Confirmar',
      registoCMD_pageTitle: 'Bem-vindo!',
      registoCMD_multi_language_pageTitle: 'Definição de idioma',
      registoCMD_before_continue_cmd_title: 'Antes de Continuar',
      registoCMD_dateFormat: 'DD-MM-YYYY',
    },
    login: {
      login_email: 'Email',
      login_errorRequestNewCode:
        'Ocorreu um erro.\r\n Por favor solicite um novo código.',
      login_emailPlaceholder: 'Insira o seu email',
      login_password: 'Password',
      login_passwordPlaceholder: 'Insira a sua Password',
      login_submit: 'Entrar',
      login_newRegister: 'Novo Registo',
      login_recoverPassword: 'Recuperar e-mail | palavra-passe',
      login_welcome: 'Bem-vindo!',
      login_loginError:
        'Não foi encontrado nenhum registo no myAdvanceCare com os dados inseridos.',
      login_updatedTerms: 'Atualizámos os nossos termos e condições',
      login_updatedTermsDescription:
        'Melhoramos o myAdvanceCare a pensar em si e atualizamos os nossos termos e condições.',
      login_acceptConditions: 'Li, compreendi e aceito os ',
      login_acceptConditionsLink: 'Termos e Condições do myAdvanceCare',
      login_beforeYouContinue: 'Antes de continuar...',
      login_beforeYouContinueDescription:
        'Pedimos que leia e aceite os nossos Termos e Condições e a nossa Política de Tratamento de Dados Pessoais. Os consentimentos para comunicações de marketing e prevenção podem ser geridos a partir dos dados de registo.',
      login_acceptPrivacyPolicy: 'Li, compreendi e aceito a ',
      login_acceptPrivacyPolicyLink:
        'Política de Tratamento de Dados Pessoais do myAdvanceCare',
      login_passwordError:
        'Insira uma palavra-passe com pelo menos uma maiúscula, um número e oito caracteres',
      login_changePassword: 'Alterar palavra-passe',
      login_changePassword_insertCode:
        'Insira o código que foi enviado para o e-mail',
      login_changePassword_andDefineNewPass: 'e defina uma nova palavra-passe',
      login_changePassword_confirmationCode: 'Código de confirmação',
      login_changePassword_sendNewCode: 'Enviar novo código',
      login_changePassword_newPassword: 'Nova palavra-passe',
      login_changePassword_repeatNewPassword: 'Repita a nova palavra-passe',
      login_changePassword_infoAdvancecare:
        'A palavra-passe também será alterada no AdvanceCare+',
      login_changePassword_change: 'Alterar',
      login_changePassword_pwdChanged: 'Palavra-passe alterada',
      login_forgotEmail_noEmailFound: 'Nenhum email encontrado com o nif',
      login_getListConsents: '0',
      dataTreatment_header: 'Tratamento de Dados',
      dataTreatment_exit: 'Não aceitar e sair',
      dataTreatment_title: 'Tratamento de Dados Pessoais',
      dataTreatment_description:
        'A AdvanceCare é a entidade responsável pelo tratamento dos dados pessoais facultados no âmbito do seu registo nesta plataforma.  Uma vez que o seu acesso lhe permite igualmente aceder aos dados do seu seguro, neste âmbito a AdvanceCare atua enquanto subcontratante das Seguradoras Unidas, S.A.  Seguradoras Unidas  Ao abrigo do Regulamento da Proteção de Dados, informamos que a Seguradoras Unidas, S.A., é a entidade responsável pelo tratamento dos dados pessoais facultados pelos respetivos titulares.        Os dados pessoais recolhidos visam a gestão da relação contratual e os mesmos são tratados de forma automática, ou com recurso a decisões por meios automatizados, e destinam-se e à formação, gestão e execução do presente contrato de seguro, nestes se considerando incluídos os procedimentos necessários à regularização de sinistros.        Se não concordar ou não facultar os dados solicitados, não será possível formalizar e executar o contrato de seguro.         Os dados pessoais fornecidos são conservados pelo prazo definido para cada finalidade.        Tem o direito de aceder, retificar ou completar os seus dados pessoais, assim como limitar ou opor-se ao seu tratamento ou solicitar a sua portabilidade.        Pode apresentar reclamação sobre o tratamento dos seus dados pessoais ao Encarregado da proteção de dados via epdados@seguradorasunidas.pt ou junto da Comissão Nacional de Proteção de Dados em cnpd.pt        Para mais esclarecimentos consulte, por favor, tranquilidade.pt, acoreana.pt ou a nossa Linha de Clientes através do número 707 24 07 071.        Agradecendo a sua colaboração, lembramos que é importante ter os seus dados sempre atualizados.        Por favor preste o seu consentimento para tratamento de dados pessoais sensíveis no contexto da subscrição e execução do contrato.        O consentimento é prestado por cada uma das pessoas seguras a segurar no contrato. No caso de menores de idade, o consentimento deverá ser dado por quem tenha o poder paternal (pai, mãe ou tutor legal).        A oposição a este consentimento impede a celebração do contrato ou a sua normal execução e a regularização do processo de sinistro (podendo condicionar o pagamento das prestações ou reembolso de despesas).        Declaração de consentimento        Para este efeito, o titular autoriza o Segurador, a Advancecare – Gestão de Serviços de Saúde,        S.A., ou outros subcontratantes a proceder ao tratamento de dados de saúde complementares, em regime de absoluta confidencialidade, recolhidos junto de organismos públicos e empresas especializadas e autoriza que estas prestem ao médico designado pelo Segurador, as informações e documentos que lhes sejam por este solicitados no âmbito da autorização agora conferida, mesmo depois de constatado o óbito, tendo em vista a confirmação ou o complemento dos elementos recolhidos necessários à gestão da relação contratual.        Dá o seu consentimento para que os seus dados sejam tratados, em regime de absoluta confidencialidade, para a finalidade aplicável. Se não for dado consentimento, não será realizada qualquer ação relacionada com a finalidade identificada.',
      dataTreatment_descriptionLastLine:
        'Para mais informações sobre Política de Privacidade aceda ',
      dataTreatment_moreInfo: 'aqui',
      dataTreatment_moreInfoLink: 'http://www.link.com',
      dataTreatment_continue: 'Continuar',
      dataTreatment_yes: 'Sim',
      dataTreatment_no: 'Não',
      dataTreatment_description2:
        'Ao abrigo do Regulamento da Proteção de Dados, informamos que a AdvanceCare é a entidade responsável pelo tratamento dos dados pessoais facultados no âmbito do seu registo nesta plataforma.        Os contatos do responsável e do encarregado da proteção de dados estão disponíveis aqui.        O fundamento jurídico para o tratamento é o interesse legítimo do utilizador. Para mais detalhe consulte aqui.        O titular dos dados poderá, em qualquer momento, exercer os seus direitos, veja mais detalhe aqui.              Como utilizador da nossa plataforma queremos que esteja informado da forma como tratamos os seus dados.        Não alterámos a forma como tratamos os seus dados mas sim a clareza e transparência da nossa política de proteção de dados.        Incentivamos a leitura da nossa política aqui.',
      dataTreatment_acceptPolicy:
        'Declaro que li e aceito a política de proteção de dados pessoais AdvanceCare.',
      insurance_header: 'Seguro',
      insurance_title: 'A informação sobre o seu seguro sempre à mão',
      insurance_title_firstLine: 'A informação sobre',
      insurance_title_secondLine: 'o seu seguro sempre à mão',
      insurance_description:
        'Ao aderir está também a contribuir para um planeta mais saudável, já que passaremos a enviar-lhe a comunicação relativa à utilização do seu seguro de saúde via digital. Ao concordar, a ativação de envio digital é imediata, e passa a ficar disponível no myAdvanceCare.',
      insurance_seeMore: 'Para saber mais sobre estas comunicações, ',
      insurance_seeMoreLink: 'aceda aqui',
      insurance_accept: 'Concordo',
      insurance_decline:
        'Não concordo, quero continuar a receber as comunicações por carta',
      insurance_understood: 'Compreendi',
      insurance_moreInfo: 'Mais Informação',
      insurance_moreInfoDescription:
        'As comunicações enviadas no âmbito desta autorização são: <p></p>1. Fusce nec ullamcorper lorem, sed ornare ligula. Nam eget rhoncus massa. <p></p>2. Malesuada nunc. Sed in ullamcorper mi. Maecenas suscipit. <p></p>3. turpis a rhoncus auctor, nulla justo porttitor massa, a efficitur neque lacus eu est. <p></p>4. Nunc interdum velit eget tellus hendrerit elementum tincidunt eget tortor. <p></p>5. Quisque accumsan elementum metus, sed vulputate lorem luctus eu. Integer egestas consectetur leo, vel feugiat ex finibus at. Donec vel venenatis mauris. Aenean sollicitudin a nisl eget porttitor.',
      insurance_moreInfoButton: 'Compreendi',
      insertCode_accessPin: 'PIN de acesso',
      insertCode_accessPinDescription:
        'Defina um PIN de acesso para um login mais rápido.',
      insertCode_insertPin: 'Insira o seu PIN',
      insertCode_confirmPin: 'Confirme o seu PIN',
      insertCode_touchIDLogin: 'Login com TouchID',
      insertCode_invalidCode: 'Erro na inserção do PIN',
      insertCode_invalidCodeDescription:
        'O PIN inserido não coincide com o PIN de confirmação',
      insertCode_okButton: 'Ok',
      login_acceptPrivacyPolicyUrl:
        'https://webappportalssodev.azurewebsites.net/Content/DataProtectionPolicy/pt/Política de protecção de dados - AdvanceCare.pdf',
      login_acceptConditionsUrl:
        'https://webappportalssodev.azurewebsites.net/Content/TermsAndConditions/pt/Termos e condições gerais - site geral.pdf',
      insurance_declineButton: 'Não Concordo',
      login_forgotPassword: 'Esqueci-me da palavra-passe',
      login_forgotPassword_mailNotification:
        'Enviaremos um e-mail com as instruções para redefinir a sua palavra-passe.',
      login_forgotPassword_dontRememberEmail: 'Não me lembro do meu e-mail',
      login_forgotPassword_continuar: 'Continuar',
      login_pageTitle: 'Login',
      login_forgotEmail_dontRememberEmail: 'Não me lembro do meu e-mail',
      login_forgotEmail_fillNif:
        'Preencha o seu NIF para tentar encontrar a sua conta.',
      login_forgotEmail_button: 'Continuar',
      login_forgotPassword_dialog_title: 'Deseja registar-se',
      login_forgotPassword_dialog_text:
        'Não foi encontrado nenhum registo no myAdvanceCare com os dados inseridos.',
      login_forgotPassword_dialog_okButton: 'Sim',
      login_forgotPassword_dialog_cancelButton: 'Não',
      login_forgotPassword_email: 'E-mail',
      login_forgotEmail_registerFound_title: 'Registo encontrado',
      login_forgotEmail_registerFound_text:
        'Foi encontrado um registo no myAdvanceCare com o e-mail:',
      login_forgotEmail_registerFound_button: 'Ir para Login',
      insertCode_forgotPIN: 'Esqueceu-se do seu PIN?',
      login_needHelp: 'Precisa de ajuda? Ligue-nos!',
      login_advPhoneNumber: '213 228 000',
    },
    messages: {
      requiredField: 'Este campo é obrigatório.',
      atLeastOneImage: 'É necessário adicionar pelo menos uma imagem.',
      selectImage: 'Selecione a imagem',
      invalidEmail: 'O endereço de e-mail não é válido. Por favor verifique.',
      invalidDate: 'Tem de selecionar uma data a partir do dia de hoje',
      selectOption: 'Selecionar opção',
      general_errorMessage: 'Ocorreu um erro. Por favor tente mais tarde',
      invalidEmailFormat: 'O formato do email não é válido',
      invalidFormat: 'O formato não é válido',
      passwordsDontMatch: 'Os dados introduzidos não coincidem',
      invalidIBAN: 'O IBAN inserido não é válido',
      appVersion_ios: '2.0.3',
      appVersion_android: '2.0.3',
      appVersion_popup_ativa: '0',
      appVersion_title_popup: 'Nova versão da app disponível',
      appVersion_description_popup:
        'Melhoramos a experiência. Aceda à sua app store e atualize para ter acesso a nova versão da app.',
      appVersion_ok_popup: 'Ok',
      graphqlErrorTitle: 'Falha ao iniciar a app',
      graphqlErrorButton: 'Ir para o Login',
      instability_alert_web:
        'Estamos a melhorar a experiência pelo que poderá encontrar algumas instabilidades. Prometemos ser breves.',
      instability_alert_mobile:
        'Estamos a melhorar a experiência pelo que poderá encontrar algumas instabilidades. Prometemos ser breves.',
      instability_alert_active: '1',
      instability_alert_active_web: '1',
      apiError_digitalCom_title: 'Ocorreu um erro.',
      apiError_digitalCom_description:
        'Pode dar este consentimento na sua área de Permissões',
      apiError_digitalCom_webTitle: 'Informação sempre à mão',
      changeBuMiddleRequestTitle: 'Deseja mudar de BU?',
      changeBuMiddleRequest: 'Caso o faça perderá os dados do pedido actual.',
      if_feature_flags_down: '',
      ff_teste: '',
      amyadv3464detalhemedicotabhospitaiseclinicas: '',
      amyadv36543472detalheprestadorestabseconsultas: '',
      amyadv3708detalheprestadores: '',
      app3458passwordlogin: '',
      app3459atomedicoem: '',
      loadingData_wait: 'Aguarde uns instantes,',
      loadingData_reason: 'estamos a carregar os seus dados.',
      loading_your_insurance_data: 'Loading your information...',
      card_selector_title: 'Cartões',
      card_selector_subtitle: 'Que seguro/plano deseja ver?',
      default_currency_code: 'EUR',
      default_vat_format: '^\\d\\d\\d\\d\\d\\d\\d\\d\\d$',
      default_language: 'pt-PT',
      updatedIBAN: 'O seu IBAN foi alterado com sucesso.',
      updatedIBAN_moreInfo:
        'A partir desta data as suas despesas serão processadas para o novo IBAN, incluindo as que submeteu anteriormente e que ainda não foram reembolsadas.',
      updatedBankAccountData: 'Your BAnk Account Data was successfuly updated',
      document_sizeAlert: 'O tamanho do ficheiro não pode exceder os 10MB.',
      documents_sizeAlert:
        'O tamanho total dos ficheiros não pode ser superior a 10MB.',
      error_loading_detail: 'Não é possivel apresentar o detalhe solicitado',
    },
    insuranceHistory: {
      insuranceHistory_title: 'Histórico de utilização',
      insuranceHistory_filterButton: 'Filtro',
      insuranceHistory_filterTitle: 'Filtrar Histórico',
      insuranceHistory_filterCoverageLabel: 'Cobertura',
      insuranceHistory_filterDateLabel: 'Período',
      insuranceHistory_filterButtonText: 'Filtrar',
      insuranceHistory_sendBy: 'ENVIADO POR MIM',
      insuranceHistory_noResults:
        'Ainda não há informação sobre a utilização do seu seguro',
      insuranceHistory_verifyHistory:
        'Verifique o histórico de utilização do seu seguro',
      insuranceHistory_filterDataLabelShort: 'Periodo',
      insuranceHistory_detailSentByMe: 'Enviado por mim',
      medicalActIn: 'Ato médico em',
      insuranceHistory_detail_error:
        'Ocorreu um erro. Não foi possível visualizar o detalhe da despesa.',
    },
    IRS: {
      IRS_title: 'Declaração de IRS',
      IRS_text: 'Consulte a sua declaração de valores a declarar',
      IRS_documentTitle: 'Declaração valores a declarar ',
      irs_emptyList:
        'As declarações de IRS estão em processo de elaboração e emissão. Serão disponibilizadas no seu Portal tão breve quanto possível.',
    },
    menu: {
      menu_insurance_app: 'Seguro',
      menu_insurance_web: 'Seguro',
      menu_medicalNetwork_app: 'Rede',
      menu_medicalNetwork_web: 'Rede Médica',
      menu_requests_app: 'Pedidos',
      menu_requests_web: 'Pedidos',
      menu_start_app: 'Início',
      menu_start_web: 'Início',
      menu_start_subitem_utilization: 'Histórico de utilização',
      menu_start_subitem_myData: 'Os meus dados',
      menu_start_subitem_coverages: 'As minhas coberturas',
      menu_start_subitem_services: 'Os meus serviços',
      menu_start_subitem_irs: 'Declaração de IRS',
      menu_start_subitem_refund: 'Reembolsos',
      menu_start_subitem_preAuthorizations: 'Pré-autorizações',
    },
    virtualCard: {
      ClienteSemNumero: '',
      NaoCliente: '',
      ClienteNaoEncontradoComCartao: '',
      VCCardNumber_title: 'Aceda a todas as funcionalidades do myAdvanceCare!',
      VCCardNumber_link: 'http://www.advancecare.pt',
      VCCardNumber_subtitle: 'Indique-nos o seu número do seu cartão:',
      VCCardNumber_inputPlaceholder: 'Número do cartão',
      VCCardNumber_underInputText: 'conheça as funcionalidades',
      VCNeedInsurance_title: 'Precisa de um seguro de saúde?',
      VCNeedInsurance_subtitle: 'Conheça as soluções e os contactos.',
      VCError_title: 'Estamos a analizar os seus dados de seguro.',
      VCError_subtitle:
        'Após a confirmação terá acesso às informações do seu seguro',
      changeInsurance: 'Mudar Seguro',
      VCError_decription:
        'Após a confirmação terá acesso às informações do seu seguro.',
      VCViewCard: 'Ver cartão',
      VCErrorNotFound_title:
        'Os dados inseridos anteriormente não foram encontrados.',
      VCErrorNotFound_subtitle: 'Inserir novos dados',
      changeInsuranceData_pageTitle: 'Seguro',
      changeInsuranceData_title: 'Confirmação de dados',
      changeInsuranceData_subTitle:
        'Aceda a todas as funcionalidades do myAdvanceCare!',
      changeInsuranceData_subTitleBottom: 'Por favor, indique-nos:',
      changeInsuranceData_birthDatePlacehoder: 'Data de nascimento',
      changeInsuranceData_insurancePlaceholder:
        'Seguradora ou sistema de saúde',
      changeInsuranceData_insuranceNumberPlaceholder:
        'Número do cartão do seguro',
      changeInsuranceData_button: 'Confirmar',
      changeInsuranceData_notFoundError_title:
        'Os dados inseridos não foram encontrados.',
      changeInsuranceData_notFoundError_text:
        'Por favor, contate a sua seguradora, mediador ou sistema de saúde.',
      changeInsuranceData_notFoundError_button: 'Ok',
      changeInsuranceData_ageError_title:
        'O utilizador menor não pode aderir ao myAdvanceCare.',
      changeInsuranceData_ageError_text:
        'O registo deve ser efetuado por quem tem responsabilidade parental. Caso pretenda associar o seguro ou plano de saúde, o registo deve ser efetuado pelo subscritor da apólice.',
      changeInsuranceData_ageError_button: 'Ok',
      changeInsuranceData_ageError_button_web: 'Compreendi',
      changeInsuranceData_notFoundError_button_web: 'Compreendi',
      changeInsuranceData_generalErrorOcurred: 'Ocorreu um erro.',
      changeInsuranceData_generalErrorTryAgain: 'Por favor tente mais tarde.',
      changeInsuranceData_insertedNif: 'NIF inserido:',
      changeInsuranceData_wrongNif: 'O seu NIF está incorreto? Faça um',
      changeInsuranceData_newNif: 'novo registo',
      changeInsurance_wishToContinue_title: 'Alterar e-mail de registo',
      changeInsurance_wishToContinue_question: 'Deseja continuar?',
      changeInsurance_wishToContinue_text:
        'Esta alteração eliminará o seu registo e criará um novo. Para continuar, insira a sua palavra-passe e confirme.',
      changeInsurance_password_placeholder: 'Palavra-passe',
      changeInsurance_wishToContinue_okButton: 'Confirmar',
      changeInsurance_wishToContinue_cancelButton: 'Cancelar',
      changeInsurance_wishToContinue_errorPassword: 'Palavra-passe errada',
    },
    legalInformation: {
      legalInformation_title: 'Informações legais',
      legalInformation_subtitle:
        'Aconselhamos a leitura cuidada e atenta dos presentes Termos e Condições e da Política de Tratamento de Dados Pessoais',
    },
    oneTrust: {
      tokenMyAdv: '',
      idCollectionPointMyAdv: '',
      idCollectionPointADVPlus: '',
      versionTermsAndConditions: '0',
      purposeTermsAndConditions: '',
      purposePolicyDataTreatment: '',
      purposeMarketingComunications: '',
      purposeHealthPrevention: '',
      purposeHealthData: '',
      porpose_clinic_consentimento: '403d3df7-277c-4671-be1b-af8397e4c9f4',
      porpose_clinic_politica: '2e607e07-aaed-41dc-8fe1-bb6384e8d699',
      porpose_clinic_enquadramento: '716951c9-bf97-4634-8a60-da2bcf60a9a7',
      porpose_clinic_terms_main: '7fabfb69-1c14-4615-b269-3979b9e104f7',
      porpose_clinic_consentimento_show: 'false',
      porpose_clinic_terms_main_show: 'true',
      porpose_clinic_enquadramento_show: 'false',
      porpose_clinic_politica_show: 'true',
      version_porpose_terms_main: '1',
    },
    medicalNetwork: {},
    pinAuthorization: {
      pinAuthentication_header: 'Segurança',
      pinAuthentication_title: 'Para prosseguir insira o seu PIN',
      pinAuthentication_pin: 'PIN',
      pinAuthentication_errorMessage: 'O PIN está incorreto',
    },
    appointments: {
      default_currency: '€',
      appointments_next_appointments: 'PRÓXIMA(S) CONSULTA(S)',
      appointments_previous_appointments: 'CONSULTA(S) REALIZADA(S)',
      appointments_no_results:
        'Ainda não foi realizada nenhuma marcação de consulta',
      appointments_confirmed: 'Consulta confirmada',
      appointments_beginning: 'Consulta a iniciar',
      appointments_began: 'Consulta iniciada',
      appointments_pending: 'Consulta pendente',
      appointments_pending_payment: 'Pagamento pendente',
      appointments_pending_title: 'Consulta dependente de pagamento',
      appointments_pending_text:
        'Para confirmar a sua consulta efetue o pagamento.',
      appointments_finished: 'Consulta terminada',
      appointments_cancelled: 'Consulta sem efeito',
      appointments_cancelled_error_text:
        'Consulta cancelada ou sem confirmação de pagamento.',
      appointments_cancelled_text:
        'Para marcar a consulta terá de efetuar uma nova marcação.',
      appointments_today: 'Hoje',
      appointments_tomorrow: 'Amanhã',
      appointments_schedule_appointment: 'Marcar consulta',
      appointments_detail_header: 'Detalhe da consulta',
      appointments_detail_patient: 'Paciente:',
      appointments_detail_modify: 'Alterar',
      appointments_detail_or: 'ou',
      appointments_detail_cancel: 'Cancelar',
      appointments_detail_cancel_appointment: 'a marcação',
      appointments_detail_payment: 'Pagamento',
      appointments_detail_paid: 'Pagamento efetuado',
      appointments_detail_motive: 'Motivo da consulta',
      appointments_detail_languages: 'Idiomas',
      appointments_detail_academic_background: 'Formação Académica',
      appointments_detail_starting_soon: 'A começar brevemente',
      appointments_detail_appointment_ended: 'Consulta terminada',
      appointments_detail_consult_conditions: 'Consulte as ',
      appointments_detail_consult_conditions_link:
        'condições de alteração e de cancelamento',
      appointments_detail_payment_cc: 'Credit Card',
      appointments_detail_payment_mb: 'Multibanco',
      appointments_detail_payment_mbw: 'MbWay',
      appointments_detail_payment_mb_entity: 'Entidade:',
      appointments_detail_payment_mb_reference: 'Referência:',
      appointments_detail_payment_mb_amount: 'Montante:',
      appointments_detail_payment_finalize_cc: 'Finalize o seu pagamento',
      appointments_detail_payment_finalize_mbw:
        'Finalize o seu pagamento na app.',

      appointments_detail_payment_pay_until:
        'Para reservar a hora da consulta confirme o pagamento na sua aplicação',
      appointments_detail_payment_paid: 'Pagamento efetuado',
      appointments_detail_shared_files: 'Documentos partilhados',
      appointments_detail_add_files: 'Adicionar outros documentos',
      appointments_detail_appointment: 'Consultas',
      appointments_detail_curricular_info: 'Informação curricular',
      appointments_finished_short: 'Terminada',
      // novo
      appointments_detail_start_appointment: 'Iniciar vídeo-chamada',
      appointments_error: 'Ocorreu um erro, por favor tente mais tarde',
      appointments_timeoutError: 'O tempo de espera foi excedido',
      appointments_timeoutTryLater: 'Por favor tente mais tarde.',
      appointments_popupConfirm: 'Confirmar',
      appointments_next_appointment: 'Próxima consulta',
      appointments_payment_pending: 'Consulta dependente de pagamento',
      appointments_payment_pending_confirm:
        'Para confirmar a sua consulta efetue o pagamento.',
      appointments_payment_pending_confirm_cc:
        'Para confirmar a sua consulta efetue o pagamento',
      appointments_payment_pending_confirm_cc_link: 'aqui',
      appointments_payment_pending_confirm_mb:
        'Para confirmar a sua consulta efetue o pagamento com os seguintes dados:',
      appointments_payment_pending_confirm_mbw:
        'Para confirmar a consulta efetue o pagamento na app MbWay ou na app do seu banco.',
      appointments_understood: 'Compreendi',

      appointments_cancelled_title: 'Consulta sem efeito',
      appointments_cancelled_appointment_error:
        'Não foi possível confirmar o pagamento.',
      appointments_cancelled_appointment_reschedule:
        'Para marcar a consulta terá de efetuar uma nova marcação.',
      appointments_cancel_title: 'Deseja cancelar?',
      appointments_cancel_text:
        'Ao continuar perderá a marcação e toda a informação associada',
      appointments_cancel_confirm: 'Consulta cancelada',
      appointments_cancel_confirm_text:
        'Os dados da sua consulta foram eliminados com sucesso.',
      appointments_legalinfo_confirm: 'Compreendi',
      appointments_schedule_before_continue: 'Antes de continuar...',
      appointments_schedule_before_continue_description:
        'Com o serviço Médico Online, pode falar com um médico por videochamada, que o orientará para os cuidados médicos mais apropriados. Um médico mais perto de si, a qualquer hora e a partir de qualquer lugar, de forma simples e segura. Serviço prestado pela Europ Assistance – Serviços de Assistência Personalizada S.A., assumindo esta a entidade a responsabilidade integral pela sua prestação. Saiba mais ',
      appointments_schedule_before_continue_description_aqui: 'aqui.',
      appointments_schedule_before_continue_description_2:
        'A confidencialidade dos seus dados é importante para nós. Leia com atenção toda a informação apresentada.',
      appointments_schedule_before_continue_description_aqui_url: '',
      appointments_schedule_before_continue_purpose1: 'Li e aceito a ',
      appointments_schedule_before_continue_purpose1_link:
        'Política de Privacidade',
      appointments_schedule_before_continue_purpose1_url: '',
      appointments_schedule_before_continue_purpose2: 'Li e aceito os ',
      appointments_schedule_before_continue_purpose2_link:
        'Termos e Condições Legais',
      appointments_schedule_before_continue_purpose2_url: '',
      appointments_schedule_before_continue_purpose3: 'Li e aceito a ',
      appointments_schedule_before_continue_purpose3_link:
        'Política de Privacidade',
      appointments_schedule_before_continue_purpose3_url: '',
      appointments_schedule_before_continue_purpose4: 'Li e aceito os',
      appointments_schedule_before_continue_purpose4_link:
        'Termos e Condições Legais',
      appointments_schedule_before_continue_purpose4_url: '',
      appointments_history_title: 'Consultas Online',
      appointments_history_subtitle: 'Verifique o estado das suas consultas',
      appointments_schedule_upcoming_limit_default: '20',
      appointments_choosePatient_header: 'Marcação de Consulta',
      appointments_schedule_leave: 'Sair da marcação',
      appointments_schedule_return: 'Regressar',
      appointments_schedule_steps: 'Faça a sua marcação em 3 passos',
      appointments_schedule_step1: 'Paciente',
      appointments_schedulo_step1_title: 'Confirme o Seguro e o paciente',
      appointments_detail_confirm: 'Confirmar',
      appointments_schedulo_step2_title:
        'Escolha a especialidade Médica que pretende',
      appointments_schedule_step2_title_doctor:
        'Selecione a melhor opção para si',
      appointments_schedule_step2: 'Médico e hora',
      appointments_choosePatiente_error:
        'A sua BU não permite que marque uma consulta online.',
      appointments_speciality_doctor_list_title:
        'Seleccione a melhor opção para si',
      appointments_speciality_doctor_list_no_results:
        'Nenhuma slot encontrada.',
      appointments_prices_may_vary:
        'Os preços das consultas podem variar consoante as condições do seu seguro ou plano de saúde',
      appointments_schedule_step3: 'Confirmação',
      appointments_schedule_step3_title: 'Efetue o pagamento',
      appointments_schedule_step3_title_no_price:
        'Confirme os detalhes da consulta',
      see_more: 'Ver mais',
      see_less: 'Ver menos',
      appointments_choose_payment_method: 'Selecione o método de pagamento',
      appointments_total: 'Total',
      appointments_schedule_pay_until:
        'Para reservar a hora da consulta efetue o pagamento',
      appointments_schedule_before_continue_continue: 'Continuar',
      appointments_payment_expires_in_cc: '20',
      appointments_payment_expires_in_mb: '20',
      appointments_payment_expires_in_mbw: '4',
      appointment_created_successfully_description:
        'Os dados da consulta estão disponíveis na área de consultas.',
      appointment_cancel_popup_title: 'Alteração de Consulta',
      appointments_schedule_limit_error_title: 'Marcações limitadas',
      appointments_schedule_limit_error1: 'Limite de',
      appointments_schedule_limit_error2: 'marcações de consultas excedido.',
      appointments_schedule_limit_error3:
        'Deverá realizar uma das consultas agendadas antes de iniciar uma nova marcação.',
      appointments_medicalNetwork_medicOnlineBanner_title: 'Consultas online',
      appointments_medicalNetwork_medicOnlineBanner_subtitle:
        'Marque as suas consultas online com médicos especializados.',
      appointments_medicalNetwork_medicOnlineBanner_button:
        'Marcar consulta online',
      appointments_see_other_views: 'Ver outras disponibilidades',
      appointments_day_time_button: 'Por dia e hora',
      appointments_by_medic_button: 'Por médico',
      appointments_goback: 'Regressar',
      appointments_see_daytime: 'Ver disponibilidades por dia e hora',
      appointments_see_doctor: 'Ver disponibilidades por médico',
      appointments_schedule_day_time_title: 'Selecione a melhor opção para si',
      appointments_schedule_day_time_no_slots:
        'Não existem médicos disponíveis para o horário selecionado. Por favor, tente outro horário',
      appointments_time_periods:
        'Madrugada/00:00-05:50,Manhã/06:00-12:59,Tarde/13:00-19:59,Noite/20:00-23:59',
      appointments_slots_available: 'Vagas disponíveis para marcação',
      appointments_schedule_error_title: 'Marcação de consulta',
      appointments_schedule_error_subtitle:
        'Detetámos um problema na confirmação da marcação.',
      appointments_schedule_error_description_1:
        'Tente novamente mais tarde ou ligue',
      appointments_schedule_error_phone: '213 228 000',
      appointments_schedule_error_description_2:
        'e marque com um dos nossos assistentes.',
      appointments_legalinfo_text:
        'Pode proceder à alteração ou cancelamento da sua marcação de consulta online no máximo até 24 horas antes da consulta.\nPara alterar a sua consulta deverá escolher uma nova data e hora preferencial mediante a disponibilidade do médico e confirmar a nova marcação.\nCaso proceda ao cancelamento dentro do prazo acima indicado, receberá um e-mail de confirmação de cancelamento e, quando aplicável, será reembolsado na totalidade do montante da consulta, sendo este creditado na sua conta bancária.',
      appointments_error_bu_func:
        ' A BU Selecionada não tem acesso a esta funcionalidade.',
      appointments_date: 'Data',
      appointments_day_period: 'Período do dia',
      appointments_interval: 'Intervalo de horas',
      appointments_at: 'às',
      appointments_legalinfo_title: 'Termos e Condições',
      appointments_date_pattern: 'Dia [DD] de [MM] às [HH]',
      appointments_until: 'até às',
      appointments_email_error: 'O seu E-mail já está a ser utilizado.',
      appointments_findAppointment: 'Encontrar consulta por',
      appointments_findAppointmentByDayAndHour: 'Dia e hora',
      appointments_findAppointmentByDoctor: 'Médico',
      appointments_findAppointmentByDoctorActive: '1',
      appointments_confirm: 'Confirmar',
      appointments_scheduleByDoctor: 'Marcação por médico',
      appointments_scheduleByDoctorSearchPlaceholder: 'Que médico procura?',
      appointments_scheduleByDoctorSearch: 'Pesquisar',
      appointments_scheduleByDoctorSearchNoResults:
        'Médico sem agenda disponivel para marcação.',
      appointments_scheduleByDoctorSearchNoResults2:
        'Sugerimos que pesquise por outro médico ou faça a pesquisa ',
      appointments_scheduleByDoctorSearchNoResultsDayAndHour: 'por dia e hora.',
      appointments_scheduleByDoctorSearchResults: ' resultado(s)',
      cancellation_limit_time: '15',
      change_limit_time: '60',
      appointments_time_expired_alert_title: 'Impossivel efectuar pedido',
      appointments_alert_text: 'A sua consulta será em menos de',
      appointments_cancel_alert_text_2:
        'minutos, logo não é possivel o seu cancelamento.',
      appointments_change_alert_text_2:
        'minutos, logo não é possivel a sua alteração.',
      appointment_change_popup_title: 'Alteração de Consulta',
      appointments_change_confirm: 'Alterada com sucesso',
      appointments_change_confirm_text:
        'Pode consultar os detalhes da consulta na lista das próximas consultas.',
      appointments_change_confirm_btn_label: 'Compreendi',
      appointments_schedule_medical_data_title: 'Dados médicos',
      appointments_schedule_medical_data_description:
        'Para facilitar a prescrição de medicamentos, solicitamos que preencha os seguintes dados:',
      appointments_schedule_insert_phone: 'Insira o nº de telemóvel',
      appointments_schedule_insert_patient_number:
        'Insira o nº de utente de saúde',
      appointment_schedule_checkbox_data:
        'Atualizar o número de telemóvel nos meus dados de perfil.',
      appointment_schedule_patient_number_label: 'Nº de Utente de Saúde',
      appointment_schedule_medical_data_phone_label: 'Nº de Telemóvel',
      appointments_free_appointment: 'Consulta gratuita',
      schedule_appointment_time_periods: '00:00-07:59,08:00-15:59,16:00-23:59',
      appointments_doctor_details_title: 'Detalhes do médico',
    },
    personalInfoConfirmation: {
      personal_information_days_between_update: '365',
      personal_information_confirmation: 'Dados pessoais',
      personal_information_confirmation_title: 'Confirmação de dados pessoais',
      personal_information_confirmation_subtitle:
        'Verifique se os seus dados estão corretos:',
      personal_information_confirmation_email: 'E-mail para contacto',
      personal_information_confirmation_phone: 'Telemóvel',
      personal_information_confirmation_phone_missing:
        'Sem informação. Por favor clique em “Alterar dados” para atualizar o seu contacto',
      personal_information_confirmation_button_confirm: 'Confirmar',
      personal_information_confirmation_button_update_data: 'Alterar dados',
    },
    preComparticipacao: {},
    language: '',
  },
};
